export default {
    "en": {
        "all": "All",
        "edit": "Edit",
        "dashboard": "Dashboard",
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "source": "Source",
        "Sourcelms": "Sourcelms",
        "personal_chats": "Personal chat rooms",
        "profile": "Profile",
        "logout": "Logout",
        "login": "Login",
        "back": "Back",
        "password": "Password",
        "do_login": "Log In",
        "forgot_password": "Forgot password?",
        "login_error": "Login failed",
        "your_message": "Your message",
        "last_messages": "Last messages",
        "no_messages": "No new messages",
        "new_messages": "new messages",
        "attach_file": "Attach file",
        "drag_n_drop": "Drop file to upload",
        "invite_to_whiteboard": "Invite to whiteboard",
        "whiteboard": "Whiteboard",
        "whiteboard_fail_create": "Failed to create whiteboard link",
        "no_cookies": "Your browser has disabled reading and saving cookies",
        "enter_reset_password": "The password will be sent to you according to the chosen method of recovery",
        "reset_password": "Restore password",
        "photo": "Photo",
        "upload": "Upload",
        "surname": "Surname",
        "patronymic": "Patronymic",
        "admin_login": "Admin login",
        "name": "First name",
        "phone": "Phone",
        "emailORphone": "Email or Phone",
        "new_password": "New password",
        "confirm_new_password": "Confirm new password",
        "save_changes": "Save changes",
        "cancel": "Cancel",
        "file_size_limit": "File size exceeds 10 MB",
        "success_saved": "Changes have been successfully saved",
        "saving_failed": "Saving data failed",
        "upload_file": "Upload file",
        "members": "Members",
        "students": "Students",
        "teachers": "Teachers",
        "search": "Search by chat",
        "go_to_whiteboard": "Go to Whiteboard",
        "channels": "Channels",
        "send_file_fail": "An error occurred while sending a message with the file",
        "only_1_file": "Only one file can be sent at a time",
        "send": "Send",
        "typing_one": "is typing...",
        "typing_more_than_one": "are typing...",
        "email": "Email",
        "to_email": "To email",
        "loginBy": "Login by",
        "resetBy": "Restore with",
        "resetPasswordError": "Recovery error",
        "attach_validation_error1": "Files with this type of extension are not allowed to be uploaded.",
        "attach_validation_error2": "This file type is not allowed to be uploaded.",
        "attach_validation_error3": "The maximum allowable file size is 1GB",
        "common_error": "Failed to save changes",
        "go_to_moodle": "To courses",
        "go_to_courses_panel": "To new courses",
        "go_to_payer_cabinet": "Cabinet parents",
        "moodle_login": "Moodle Login",
        "moodle_password": "Moodle Password",
        "choose": "Choose",
        "choose_groups": "Choose groups",
        "choose_group": "Choose group",
        "choosen_groups": "Choosen groups",
        "students_groups": "Students groups",
        "choosen_groups_options": "Choosen options",
        "months": "january,february,march,april,may,june,july,august,september,october,november,december",
        "days": "monday,tuesday,wednesday,thursday,friday,saturday,sunday",
        "chat": "Chat",
        "courses": "Courses",
        "add_theme": "Add theme",
        "to_themes_list": "To themes list",
        "back_to_course": "Back to the course",
        "back_to_dashboard": "Back to the dashboard",
        "add_test": "Add test",
        "Ttest": "Test",
        "test_settings": "Test setting",
        "Test": "Test",
        "Exercise": "Task",
        "Import": "Import",
        "Lecture": "Lecture",
        "Lecture_one": "Lecture",
        "To": "To",
        "Add": "Add",
        "add_question": "Add a question",
        "save_question": "Save the question",
        "choose_question_type": "Choose the question type",
        "yes_no": "Yes/No",
        "no": "No",
        "yes": "Yes",
        "one_answer": "Questions with one correct answer",
        "multichoice": "Multi-choice",
        "match_text_image": "Matching text-picture",
        "match_text_text": "Matching text-text",
        "open_question": "Short answer",
        "missing_words": "Missing words",
        "total_score": "Final score",
        "Question": "Question",
        "new_lesson": "New lesson",
        "answer_variant": "Answer option",
        "answer_variants": "Answers options",
        "select_variants": "Select answers options",
        "answer_pair_variant": "Options pair",
        "answer": "Answer",
        "add_variant": "Add option",
        "save_variants": "Save options",
        "save_variants_and_question": "Save options and question",
        "answer_correct": "right answer",
        "question_with_answer": "The question must have the correct answer",
        "question_text_required": "Question text is required",
        "question_with_weight": "The question must have the score",
        "question_multiple_with_weight": "The right answer must have the score",
        "time_limit": "Time limit",
        "none": "there is not",
        "is": "there is",
        "mins": "min",
        "show_questions_on_page": "Number of questions on one page",
        "delete_question": "Delete question",
        "delete": "delete",
        "write_tries_count": "Enter the number of attempts",
        "write_questions_count": "Enter the number of questions",
        "test_name": "The name of the test",
        "next": "Next",
        "next_to": "Next",
        "last_to": "Last",
        "lesson": "lesson",
        'empty_data': "No data available",
        'remove': 'Remove',
        "remove_theme": "Delete this theme?",
        "search_theme": "Search by theme name or lesson name",
        'empty_lessons': 'There are no lessons in this theme',
        "test_results_text": "Here you can see the result of the created question",
        "test_settings_main_text": "This section provides job descriptions for teachers of secondary" +
            " schools in Ukraine.<br><br>" +
            "Teachers' job descriptions are developed in accordance with the Tariff and Qualification Characteristics\n" +
            "                of the Teacher, the Law of Ukraine \"On Education\", the Law of Ukraine \"On Occupational Safety\", the Regulations on the Organization\n" +
            "                of Work on Occupational Safety of Participants in the Educational and Educational Process in the Educational Institutions and Establishments,\n" +
            "                certification of pedagogical workers of Ukraine \", the Model provision on the labor protection service.",
        "no_consultation": "There are no scheduled consultations today.",
        "save": "Save",
        "preview": "Preview",
        "cancel_2": "Cancel",
        "load_more": "Load more",
        "new_lecture": "New lecture",
        "edit_lecture": "Edit lecture",
        "new_exercise": "New exercise",
        "edit_exercise": "Edit exercise",
        "to_lesson_content": "To lesson content",
        "go_to_lesson": "Go To Lesson",
        "lecture_name": "Lecture title",
        "exercise_name": "Exercise title",
        "publish": "Publish",
        "remove_lesson_item": "Delete this lesson item?",
        "general_information": "General information",
        "lesson_title": "Title of the lesson",
        "lesson_theme": "Theme of the lesson",
        "visibility": "Visibility",
        "lesson_description": "Description of the lesson",
        "availability": "Accessibility",
        "expected_completion_date": "Expected completion date",
        "action_after_expected_date": "Action after expected date",
        "deadline": "Deadline",
        "action_after_deadline": "Action after deadline",
        "password_protection": "Password protection",
        "enter_password": "Enter password",
        "rating": "Rating",
        "rating_type": "Type of rating",
        "scale": "Scale",
        "maximum_rating": "The maximum rating",
        "results_processing": "Processing of test results",
        "actions_options": {
            "alert": "Alert",
            "retest": "Retest",
            "mark_2": "Give a rating 2",
            "call_parents": "Call parents",
            "deduct": "Deduct",
            "mark_1": "Give a rating 1",
            "forbidden_passing": "Prohibit passage",
        },
        "edit_lesson": "Edit lesson",
        "add_new_theme": "Add a new theme",
        "theme_name": "Name",
        "save_theme": "Save theme",
        "edit_theme": "Edit theme",
        "number_of_attempts": "Number of attempts",
        "number_of_used_attempts": "Number of used attempts",
        "plus_lesson": "Lesson",
        "element_lesson": "Lesson element",
        "type_result_attempts": "Type of assessment",
        "min_grade": "Minimum score",
        "max_grade": "Maximum score",
        "middle_grade": "Average rating",
        "nothing_found": "Nothing found.",
        "reset_search": "Reset search",
        "additional_information_about_subject": "Additional information about the subject",
        "recommended_tutorials": "Recommended tutorials",
        "page_content": "Page content",
        "course": "Course",
        "materials": "Materials",
        "inspection_of_works": "Inspection of works",
        "next_lesson": "Next lesson",
        "prev_lesson": "Previous lesson",
        "home": "Home",
        "need_to_check": "Need to check",
        "optional": "Optional",
        "unverified_works": "Unverified works",
        "completed_success": "Completed (success)",
        "schedule_of_consultations": "Schedule of consultations",
        'remove_lesson': 'Delete this lesson?',
        'file_error': 'File format is not allowed',
        'remove_file': 'Delete this file?',
        'question_number': 'Question number',
        "no-unread-messages": "No new messages",
        "navigation": "Navigation",
        "search_members": "Search by members",
        "search_members_not_found": "Not found",
        "see_question_in_editor": "View the question in the editor\n",
        "time_for_testing": "Time for testing",
        "on_today": "Today",
        "popular": "Popular",
        "need_to_improve": "Need to improve",
        "current_lesson": "Current lesson",
        "previous_lesson": "Previous lesson",
        "teacher": "Teachers",
        "teachers": "Teachers",
        "consultations": "Consultations",
        "score_for_lesson": "Lesson grade",
        "test_theme": "Test theme",
        "minutes": "minutes",
        "test_start": "Start",
        "congrats_finished_ted": "Congratulations! You have finished test. Wait for your results.",
        "time_is_out": "You have run out of time.",
        "end_test": "End test.",
        "end_test_question": "End test?",
        "continue_to": "Continue",
        "make_answer": "Answer",
        "return": "Return",
        "your_answer": "Your answer",
        "unlimited": "Unlimited",
        "add_selects": "Add answer variants",
        "convert": "Convert",
        "exercise_from": "task from",
        "pin_message": "Pin",
        "choose_education_form": "Choose education form",
        "choose_all": "Choose all",
        "remove_all": "Remove all",
        "choose_option": "Choose option",
        "hide": "Hide",
        "match_right": "Match",


        "full_name": 'Full name',
        "on_check": 'Need to check',
        "year_grade": 'Year grade',
        "search_group": "Search by group name",
        "score": "score",
        "group_statistic": "Back to group statistic",
        "lesson_number": "Lesson №",
        "check": "Check",
        "exercise_answer": "Exercise_answer",
        "file": "File",
        "label_name": "Labels",
        "notes": "Notes",
        "save_button": "Save",
        "answer_exercise": "Do the exercise.",
        "score_and_comment": "Score and comment",
        "comment": "Comment",
        "student": "Student",
        "one_more_try": "One more try",
        "scored": "Scored",
        "automatic_questions": "Automatic questions",
        "open_questions": "Open questions",
        "leave_comment": "Leave a comment",
        "answers": "Answers",
        "missing": "Missing",
        "document_name": "Name",
        "document_type": "Type",
        "document_upload": "Upload",
        "document_upload_btn": "Upload document",
        "period": "Period",
        "choose_period": "Choose by period",
        "search_course": "Search by course",
        "search_curator_teacher": "Search by teachers",
        "active": "Active",
        "role": "Role",
        "student_role": "Student",
        "student_billing_role": "Billing/student",
        "billing_role": "Billing",
        "group": "Group",
        "groups": "Groups",
        "progress": "Progress",
        "curator": "Curator",
        "go_to_payment": "Go to payment",
        "packages_payment": "Packages and payment",
        "payment_history": "Payment history",
        "filter": "Filter",
        "add_document": "Add document",
        "rows": "Rows",
        "review_the_contract": "Review the document",
        "upload_doc": "Upload document",
        "upload_doc_pop": "Upload document",
        "doc_status": {
            "require_sign": "Require sign",
            "signed": "Signed",
            "require_view": "Require view",
            "for_familiarization": "For familiarization",
            "received": "Received",
            "require_account_sign": "Require accountant's sign",
        },
        "month": ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        "date": "Date",
        "name_of_doc": "Name of document",
        "status": "Status",
        "author": "Author",
        "diary": "Diary",
        "documents": "Documents",
        "achievements": "Achievement",
        "leaderboard_btn": "Leaderboard",
        "droplets": "Droplets",
        "achievements_point": "Achievements",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat",
        "Sun": "Sun",
        "level_title": "Level",
        "weekly_tasks_title": "Weekly tasks",
        "weekly_tasks_placeholder": "Your answer",
        "weekly_tasks_submit": "Send",
        "tasks_file_placeholder": "Attach a file...",
        "curators": "Curators",
        "date_and_time": "Date and time",
        "id_payment": "ID payment",
        "name_student": "Full name student",
        "summ": "Amount",
        "payment_for": "Payment for",
        "total": "Total",
        "search_history": "Search by history",
        "search_documents": "Search by documents",
        "success_document": "Document successfully added",
        "pagination_show_count": {
            "show": "Show",
            "rows": "rows of"
        },
        "valid_file_types": "Valid file types are jpg, jpeg, png, pdf",
        "valid_file_types_2": "Valid file types are",
        "inn": "TIN",
        "passport": "Series, passport number",
        "issued_passport": "The authority that issued",
        "date_passport_from": "Date of issue",
        "date_passport_to": "Valid until",
        "user_country": "Country of residence",
        "address_fact": "Address of residence",
        "diary_status": {
            "1": "The date of the lesson was to the signing of the contract",
            "2": "Certificate of illness. Evaluation does not take into account",
            "3": "The work is checked by the teacher",
            "4": "Lesson failed. Evaluation not provided",
            "5": "Lesson not passed",
            "6": "The lesson date has not yet arrived",
            "7": "Lesson passed. Evaluation not provided",
            "8": "Lesson passed",
            "9": "Lesson for today",
            "10": "Lesson partially completed",
            "11": "Grade is freezed",
            "21": "Student expelled",
            "22": "Student has a prolongation",
            "23": "Access to courses is blocked",
        },
        "test": "test",
        "try": "Try",
        "search_lesson_student": "Search by lesson",
        "empty_lessons_student": "There are no students in this lesson",
        "to_next_element": "To next element",
        "to_next_student": "To next student",
        "scored_points": "Scored points",
        "thematic_evaluation": "thematic evaluation",
        "annual_assessment": "annual assessment",
        "maths": "Mathematics Grade 7",
        "temp_date": "Mon, 13 May",
        "temp_date_2": "Mon-Fri from 8.30am to 4.00pm",
        "relevant_try": "Relevant try",
        "prev_try": "Previuos try",
        "next_try": "Next try",
        "passed": "Passed",

        "schedule": "Schedule",
        "prev": "Previuos",
        "clear": "Clear",
        "pagination_desc_part_1": "The page displays",
        "pagination_desc_part_2": "lines out of",
        "show_results": "Show results",
        "activity": "Activity",
        "sort": "Sort",
        "academic_year": "Academic year",
        "schedules_empty": "Your search did not match any records, try changing the filtering options",
        "record": "Recording",
        "record_video": "Record video",
        "record_audio": "Record audio",
        "stop": "Stop",
        "download_file": "Download",
        "add_schedule": "Add schedule",
        "search_name": "Search by name",
        "gender": "Gender",
        "male": "Male",
        "female": "Female",
        "birth_year": "Date of birth",
        "last_activity": "Last time online",
        "today": "today",
        "more_week_ago": "More week ago",
        "more_month_ago": "More month ago",
        "more_half_year": "More half year",
        "tables": "Tables",
        "studies_from": "The student studies from",
        "student_status": "Student status",
        "classes_per_year": "Classes per year",
        "final_class": "The final class",
        "for_period": "For the period",
        "expelled_students": "Expelled students",
        "from": "from",
        "from_on": "from",
        "to_on": "to",
        "gpa": "GPA",
        "number_uncompleted_works": "Number of uncompleted works",
        "number_obligatory_works": "Number of obligatory unsubmitted works",
        "show_failed_students": "Show only failed students",
        "expired_payment": "Show only students with expired payment",
        "student_name": "Name of the student",
        "label_name": "Labels",
        "statistics": "Statistics",
        "required": "Required",
        "expecteddate_after_dedlinedate": "Date error",
        "success_journal": "Journal of success",
        "assessments_journal": "Journal of assessments",
        "alphabetically": "Alphabetically",
        "score_according": "According to the average score",
        "days_ago": "days ago",
        "hours_ago": "hours ago",
        "minutes_ago": "minutes ago",
        "notify_parents": "Notification to parents",
        "notify_students": "Notification to students",
        "send_msg": "Send message",
        "reports_actions": "Actions with reports",
        "reports_documents": "Actions with documents",
        "data_export": "Data export",
        "provide_prolongation": "Provide a prolongation",
        "view_spreadsheets": "View spreadsheets",
        "send_everyone": "Send to everyone",
        "print": "Print",
        "download_all": "Download all",
        "to_chat": "To chat",
        "option_must_selected": "At least one option must be selected",
        "curators_journal": "Curator's Journal",
        "month_label": "Month",
        "add_certification": "Add certification",
        "added_certification": "Certification added successfully",
        "edit_rating": "Edit rating",
        "delete_rating": "Delete rating",
        "add_rating": "Add rating",
        "current_rating": "Current rating",
        "new_rating": "New rating",
        "certificate": "Certificate",
        "chose_date": "Chose date",
        "added_rating": "Rating added successfully",
        "changed_rating": "Rating changed successfully",
        "deleted_rating": "Rating deleted successfully",
        "title": "Title",
        "write_title": "Write title",
        "details": "Details",
        "write_details": "Write details",
        "action_dates": "Dates of action",
        "changed_successfully": "changed successfully",
        "deleted_successfully": "Deleted successfully",
        "uah": "UAH",
        "details": "Details",
        "beneficiarys_bank": "Beneficiary's bank",
        "privatbank": "JSC CB \"Privatbank\"",
        "raiffeisen": "JSC \"Raiffeisen Bank Aval\"",
        "mfo": "MFO",
        "edrpou": "EDRPOU code",
        "purpose_payment": "Purpose of payment",
        "payer_payment": "payment: for training (Surname, Name, and Parent of the Student / External) in (appropriate-indicate in numbers) class for the relevant period (specify month or months). For example: \"{last_name} {first_name} {patronymic}\"",
        "package": "Package",
        "subscription_amount": "Total subscription amount",
        "paid": "Paid",
        "remainder": "Remainder",
        "month_amount": "Amount per month",
        "total_pay": "Total to pay:",
        "recipient": "Recipient",
        "cde_source": "LLC Center for Distance Education \"Source\"",
        "cde_source_2": "LLC Center for Distance Education \"Source Plus\"",
        "whiteboard_room_fail": "Failed to create whiteboard room",
        "whiteboard_room_success": "Whiteboard room created successfully",
        "payers_document": "Payer's document",
        "accountants_document": "Accountant's document",
        "create_conspectus": "Create a conspectus",
        "lesson_import_content": "Import content from another lesson",
        "edit_conspectus": "Editing conspectus",
        "choose_pdf_material": "Select a PDF from the Materials section of the current course",
        "upload_pdf": "Download PDF from PC",
        "choose_pdf": "Select pdf file",
        "choose_file": "Select a file",
        "choose_range": "Select a range of document pages (no more than 20)",
        "from": "from",
        "to": "to",
        "is_active": "Active",
        "no_conspectus_images": "Pages not loaded in the conspectus or are in the process of being processed",
        "conspectus_name": "Title of conspectus",
        "Conspectus": "Conspectus",
        "back_to_schedules": "Back to schedules",
        "added_schedule": "Schedule added successfully",
        "deleted_schedule": "Schedule deleted successfully",
        "success_import_lesson_element": "Lesson element successfully imported",
        "error_import_lesson_element": "Lesson element not imported",
        "schedule_exist": "Schedule already exist",
        "grade_changed": "grade changed",
        "status_changed": "status changed",
        "meddoc_deleted": "medical document deleted",
        "meddoc_added": "medical document added",
        "meddoc_changed": "medical document changed",
        "show_btn": "Show",
        "oops": "Oops! Something went wrong (",
        "monthly": "Monthly",
        "changed_schedule": "Schedule changed successfully",
        "add_lesson": "Add lesson",
        "edit_schedule": "Edit schedule",
        "choose_date": "Choose date",
        "test_description": "Description",
        "max_score": "Maximum points",
        "errorTooManyAnswers": "The maximum number of answer options",
        "to_journal": "To gradebook",
        "lesson_type": "Lesson type",
        "add_score": "Add score",
        "xls_students": "Students data export",
        "xls_payers": "Payers data export",
        "set_class_package": "specify class and package",
        "doc_list_tooltip": "<p>Dear parents!</p><p>Download the contract and carefully check that all the information in the contract is correct. If there is a discrepancy, please contact the secretariat by writing a message on VIBER to the number: +38 (097) 770 50 30</p><p>If everything is true:<br />- print the contract;<br />- sign each page of the contract;<br />- scan or take high quality photos and upload to the site.</p><p>After a while, a scanned copy of the agreement signed by both parties will be available on this page below.</p><p>If you need the original contract, please contact the secretariat.</p>",
        "change_of_details": "WARNING! CHANGE OF DETAILS!!!! <br /> Please note that from June 13, 2020, due to the transition to a single MFI, PrivatBank's payment accounts have changed!",
        "add_file": "Add file",
        "server_processed": "processed by server",
        "schedule_template": "schedule template",
        "failed": "Failed",
        "checking": "Checking",
        "new": "New",
        "load_error": "Data load error",
        "timetable": "Timetable",
        "journal_status": {
            "1": "The work completed successfully",
            "2": "Expired",
            "3": "the work is checked by the teacher",
            "4": "To pass",
        },
        "lesson_date": "Lesson date",
        "edit_day": "Edit day",
        "language": "Language",
        "grade_head": {
            "thematic": "T",
            "semester": "S",
            "year": "Y",
        },
        "first_semester": "First semester",
        "second_semester": "Second semester",
        "next_year": "Next year",
        "test_results": "Test results",
        "go_again": "Go again",
        "shuffle_the_left_side": "Shuffle the left side",
        "theme_to_journal": "Theme to journal",
        "whole_schedule": "The whole schedule",
        "common_load_error": "Failed to load data",
        "holiday": "Holiday",
        "teacher_verification": "Requires teacher verification",
        "agree_rating": "Agree with rating",
        "attempts_left": "Attempts left",
        "photo_description": "Photo description",
        "photo_reverce": "Display pictures to the left",
        "confirm": "Confirm",
        "teacher_comment": "Teacher comment",
        "success_job": "Job loaded successfully",
        "recalculate_log": "Recalculate journal",
        "success_journal_recalc": "Journal successfully recounted",
        "date_passed": "Date passed",
        "delete_passing": "Delete passing",
        "ktp": "КТП",
        "instruction_not_found": "Instruction not found",
        "screen_shots": "Screen Shots",
        "possible_answers": "Possible Answers",
        "statement_type": "Type of statement",
        "student_works": "Works",
        "student_work": "Work",
        "completion_date": "Date of Completion",
        "admin_notification": "Notification from the administration",
        "add_select_options": "Add select options",
        "question_missing_count": "The number of selects in the text and answer options does not match",
        "possible_answer_type_1": "Text",
        "possible_answer_type_2": "TeXt",
        "possible_answer_type_3": "Integer Number",
        "possible_answer_type_4": "Float Number",
        "log_type": "Log type",
        "confirm_deletion": "Are you sure, you want to delete?",
        "student_page": "Student page",
        "billing_parents": "Billing / Parents",
        "student_packets": "Student packets",
        "no_active": "no active",
        "total_sum": "Total sum",
        "payments": "uah",
        "contract_from": "Сontract from",
        "contract_to": "Сontract to",
        "lesson_under_development": "Lesson is under development",
        "all_classes": "All classes",
        "mandatory_only": "Mandatory only",
        "doing_fine": "You're doing fine! Everything is handed over)",
        "selected_groups": "Selected groups",
        "generate_spreadsheets": "Generate spreadsheets",
        "publish_spreadsheets": "Publish spreadsheets",
        "export_rates": "Export rates",
        "generate_gradereports": "Generate grade reports",
        "document": "Document",
        "published": "Published",
        "not_published": "Not published",
        "no": "no",
        "to_publish": "Publish",
        "remove_doc_question": "Are you sure you want to delete the document?",
        "report_card": "Report card",
        "statement": "Statement",
        "available": "Accessible",
        "school_documents": "Documents from the previous school",
        "additional": "Additional",
        "generate_tables": "The report card will be available for viewing in a couple of minutes on the \"documents\" tab in additional information about the student",
        "generate_gradereports_success": "The class report will be available for viewing in a couple of minutes on the documents tab",
        "export_studentgrades": "The statement will be available for viewing in a couple of minutes on the \"documents\" tab in additional information about the student",
        "credited_not_credited": "Credited / Not credited",
        "credited": "Credited",
        "credited_short": "Cred.",
        "credited_not": "Not credited",
        "credited_not_short": "Not cred.",
        "recalculate_rating": "Recalculate rating",
        "recalculate_lesson": "Recalculate lesson",
        "success_lesson_recalc": "Lesson successfully recounted",
        "delayed_till": "Delayed till",
        "package_blocked": "Package blocked",
        "warning": "Warning",
        "prolongation": "Prolongation",
        "rating_block": "Block ratings",
        "rating_unlock": "Unlock ratings",
        "confirm_rating_block": "Are you sure, you want to block ratings?",
        "confirm_rating_unlock": "Are you sure, you want to unlock ratings?",
        "expelled": "Expelled",
        "not_expelled": "Not expelled",
        "choose_course_journal": "Choose course and journal",
        "mass_creation": "Mass creation",
        "journal_types": {
            "standart": "Standart",
            "family": "Family/Family+",
            "externat_t": "Externat-T",
            "externat_r": "Externat-R",
            "homeschooler": "Homeschooler",
        },
        "lesson_not_for_form": "The content of this lesson is not available for your form of study",
        "for_grades": "For grades",
        "for_students_list": "For students list",
        "сreated_schedules": "The following schedules are created:",
        "last_passing": "This is student last passing",
        "download_time": "it may take a while to download the file",
        "var_courses": "Variative courses",
        "var_courses_shot": "Var.courses",
        "education_form": "Education form",
        "disconnect_viber": "Disconnect Viber",
        "connect_viber": "Connect Viber",
        "disconnect_telegram": "Disconnect Telegram",
        "connect_telegram": "Connect Telegram",
        "notifications_channels": "Notifications Channels",
        "go_to_support_page": "Support service",
        "kw_support_title": "👋 Hi!",
        "kw_support_subtitle": "Technical Support",
    },
    "ru": {
        "all": "Все",
        "edit": "Редактировать",
        "dashboard": "Главная",
        "auth": {
            "failed": "Неправильный логин или пароль.",
            "throttle": "Слишком много попыток входа. Пожалуйста, попробуйте повторить через {seconds} секунд."
        },
        "source": "Джерело",
        "Sourcelms": "Sourcelms",
        "personal_chats": "Личные чаты",
        "profile": "Профиль",
        "logout": "Выйти",
        "login": "Логин",
        "back": "Назад",
        "password": "Пароль",
        "do_login": "Войти",
        "forgot_password": "Забыли пароль?",
        "login_error": "Ошибка входа",
        "your_message": "Ваше сообщение",
        "no_messages": "Нет новых сообщений",
        "last_messages": "Последние сообщения",
        "new_messages": "новых сообщений",
        "attach_file": "Прикрепить файл",
        "drag_n_drop": "Перетащите файл для загрузки",
        "invite_to_whiteboard": "Пригласить в whiteboard",
        "whiteboard": "Whiteboard",
        "whiteboard_fail_create": "Не удалось создать ссылку в whiteboard",
        "no_cookies": "В Вашем браузере отключено чтение и сохранение файлов cookie",
        "enter_reset_password": "Пароль прийдет вам по выбранному способу восстановления",
        "reset_password": "Восстановить пароль",
        "photo": "Фото",
        "upload": "Загрузить",
        "surname": "Фамилия",
        "patronymic": "Отчество",
        "admin_login": "Логин в админ панель",
        "name": "Имя",
        "phone": "Телефон",
        "emailORphone": "Телефон или Email",
        "new_password": "Новый пароль",
        "confirm_new_password": "Подтвердите новый пароль",
        "save_changes": "Сохранить изменения",
        "cancel": "Отмена",
        "file_size_limit": "Размер файла превышает 10 МБ",
        "success_saved": "Изменения успешно сохранены",
        "saving_failed": "Ошибка сохранения данных",
        "upload_file": "Загрузите файл",
        "members": "Участники",
        "students": "Студенты",
        "teachers": "Преподаватели",
        "search": "Поиск по чату",
        "go_to_whiteboard": "Перейти в whiteboard",
        "channels": "Каналы",
        "send_file_fail": "При отправке сообщения с файлом произошла ошибка",
        "only_1_file": "За один раз можно отправить только один файл",
        "send": "Oтправить",
        "typing_one": "печатает...",
        "typing_more_than_one": "печатают...",
        "email": "Почта",
        "to_email": "На почту",
        "loginBy": "Зайти через",
        "resetBy": "Восстановить с помощью",
        "resetPasswordError": "Ошибка восстановления",
        "attach_validation_error1": "Файлы с этим типом расширения запрещены к загрузке",
        "attach_validation_error2": "Данный тип файла запрещен к загрузке",
        "attach_validation_error3": "Максимально допустимый размер файла 1GB",
        "common_error": "Не удалось сохранить изменения",
        "go_to_moodle": "К курсам",
        "go_to_courses_panel": "К новым курсам",
        "go_to_payer_cabinet": "Кабинет родителей",
        "moodle_login": "Логин в Moodle",
        "moodle_password": "Пароль в Moodle",
        "choose": "Выбрать",
        "choose_groups": "Выбрать группы",
        "choose_group": "Выбрать группу",
        "choosen_groups": "Выбраеные группы",
        "students_groups": "Группы студентов",
        "choosen_groups_options": "Выбранные опции",
        "months": "января,февраля,марта,апреля,мая,июня,июля,августа,сентября,октября,ноября,декабря",
        "days": "понедельник,вторник,среда,четверг,пятница,суббота,воскресенье",
        "chat": "Чат",
        "courses": "Курсы",
        "add_theme": "Добавить тему",
        "to_themes_list": "К списке тем",
        "back_to_course": "Назад к курсу",
        "back_to_dashboard": "Назад на главную",
        "add_test": "Добавить тест",
        "Ttest": "Тест",
        "test_settings": "Настройки теста",
        "Test": "Тест",
        "Exercise": "Задание",
        "Import": "Импорт",
        "Lecture": "Лекцию",
        "Lecture_one": "Лекция",
        "To": "До",
        "Add": "Добавить",
        "add_question": "Добавить вопрос",
        "save_question": "Сохранить вопрос",
        "choose_question_type": "Выбрать тип вопроса",
        "yes_no": "Да/ Нет",
        "no": "Нет",
        "yes": "Да",
        "one_answer": "Вопрос с одним ответом",
        "multichoice": "Мультивыбор",
        "match_text_image": "Соответствие текст-картинка",
        "match_text_text": "Соответствие текст-текст",
        "open_question": "Краткий ответ",
        "missing_words": "Пропущенные слова",
        "total_score": "Итоговая оценка",
        "Question": "Вопрос",
        "new_lesson": "Новий урок",
        "answer_variant": "Вариант ответа",
        "answer_variants": "Варианты ответов",
        "select_variants": "Селект варианты ответов",
        "answer_pair_variant": "Пара опций",
        "answer": "Ответ",
        "add_variant": "Добавить вариант",
        "save_variants": "Сохранить опции ответов",
        "save_variants_and_question": "Сохранить опции ответов и вопрос",
        "answer_correct": "правильный ответ",
        "question_with_answer": "У вопроса должен быть правильный ответ",
        "question_text_required": "У вопроса должен быть текст",
        "question_with_weight": "У вопроса должен быть балл",
        "question_multiple_with_weight": "У правильного ответа должен быть балл",
        "time_limit": "Лимит времени",
        "none": "нет",
        "is": "есть",
        "mins": "мин",
        "show_questions_on_page": "Выводить вопросов на одной странице",
        "delete_question": "Удалить вопрос",
        "delete": "удалить",
        "write_tries_count": "Введите кол-во попыток",
        "write_questions_count": "Введите кол-во вопросов",
        "test_name": "Название теста",
        "next": "Следующий",
        "next_to": "Дальше",
        "last_to": "К последней странице",
        "lesson": "урока",
        'empty_data': "Нет данных",
        'remove': 'Удалить',
        "remove_theme": "Удалить эту тему?",
        "search_theme": "Поиск по названию теми или урока",
        'empty_lessons': 'В данной теме уроков нет',
        "test_results_text": "Тут вы сможете увидеть результат созданного вопроса",
        "test_settings_main_text": "В данном разделе приведены должностные инструкции для учителей общеобразовательных" +
            " учебных заведений Украины.<br><br>" +
            "Должностные инструкции учителей разработаны в соответствии с тарифно-квалификационной характеристики\n" +
            "                учителя Закона Украины «Об образовании», Закона Украины «Об охране труда», Положением об организации\n" +
            "                работы по охране труда участников учебно-воспитательного процесса в учреждениях i учебных заведениях, Типового\n" +
            "                положения \"Об аттестации педагогических работников Украины\", Типового положения о службе охраны труда.",
        "no_consultation": "Сегодня нет запланированных консультаций",
        "save": "Сохранить",
        "preview": "Предварительный просмотр",
        "cancel_2": "Отмена",
        "load_more": "Показать еще",
        "new_lecture": "Новая лекция",
        "edit_lecture": "Редактировать лекцию",
        "new_exercise": "Новое задание",
        "edit_exercise": "Редактировать задание",
        "to_lesson_content": "К содержимому урока",
        "go_to_lesson": "Перейти к уроку",
        "lecture_name": "Название лекции",
        "exercise_name": "Название задания",
        "publish": "Опубликовать",
        "remove_lesson_item": "Удалить этот элемент урока?",
        "general_information": "Общие данные",
        "lesson_title": "Название урока",
        "lesson_theme": "Тема урока",
        "visibility": "Видимость",
        "lesson_description": "Описание урока",
        "availability": "Доступность",
        "expected_completion_date": "Ожидаемая дата сдачи",
        "action_after_expected_date": "Действие после ожидаемой даты",
        "deadline": "Крайний срок сдачи",
        "action_after_deadline": "Действие после крайнего срока",
        "password_protection": "защита паролем",
        "enter_password": "Введите пароль",
        "rating": "Оценка",
        "rating_type": "Тип оценки",
        "scale": "Шкала",
        "maximum_rating": "Максимальная оценка",
        "results_processing": "Обработка результатов попыток",
        "actions_options": {
            "alert": "Предупредить",
            "retest": "На пересдачу",
            "mark_2": "Поставить 2",
            "call_parents": "Вызвать родителей",
            "deduct": "Отчислить",
            "mark_1": "Поставить 1",
            "forbidden_passing": "Запретить прохождение",
        },
        "edit_lesson": "Редактировать урок",
        "add_new_theme": "Добавить новую тему",
        "theme_name": "Название теми",
        "save_theme": "Сохранить тему",
        "edit_theme": "Редактировать тему",
        "number_of_attempts": "Количество попыток",
        "number_of_used_attempts": "Количество использованых попыток",
        "plus_lesson": "Урок",
        "element_lesson": "Элемент урока",
        "type_result_attempts": "Тип оценивания",
        "min_grade": "Минимальная оценка",
        "max_grade": "Максимальная оценка",
        "middle_grade": "Средняя оценка",
        "nothing_found": "Ничего не найдено.",
        "reset_search": "Сбросить поиск",
        "additional_information_about_subject": "Дополнительная информация о предмете",
        "recommended_tutorials": "Рекомендуемые учебники",
        "page_content": "Содержание страницы",
        "course": "Курс",
        "materials": "Материалы",
        "inspection_of_works": "Проверка работ",
        "next_lesson": "Следующий урок",
        "prev_lesson": "Предыдущий урок",
        "home": "Главная",
        "need_to_check": "Надо проверить",
        "optional": "Факультатив",
        "unverified_works": "Не проверено работ",
        "completed_success": "Завершено (успех)",
        "schedule_of_consultations": "Расписание консультаций",
        'remove_lesson': 'Удалить этот урок?',
        'file_error': 'Неразрешенный формат файла',
        'remove_file': 'Удалить этот файл?',
        'question_number': 'Номер вопроса',
        "no-unread-messages": "Нет новых сообщений",
        "navigation": "Навигация",
        "search_members": "Поиск по участникам",
        "search_members_not_found": "Не найдено",
        "see_question_in_editor": "Просмотрите вопрос в редакторе",
        "time_for_testing": "Время тестирования",
        "on_today": "На сегодня",
        "popular": "Популярные",
        "need_to_improve": "Нужно подтянуть",
        "current_lesson": "Текущий урок",
        "previous_lesson": "Предыдущий урок",
        "teacher": "Учительская",
        "teachers": "Учителя",
        "consultations": "Консультации",
        "score_for_lesson": "оценка за урок",
        "test_theme": "Тест с темы",
        "minutes": "минут",
        "test_start": "Начать",
        "congrats_finished_ted": "Молодец! Ты окончил(ла) тестирование. Ожидай результаты в ближайшее время.",
        "time_is_out": "Время прохождения теста вышло.",
        "end_test": "Закончить прохождения теста.",
        "end_test_question": "Закончить прохождения теста?",
        "continue_to": "Перейти дальше",
        "make_answer": "Ответить",
        "return": "Вернуться",
        "your_answer": "Твой ответ",
        "unlimited": "Неограничено",
        "add_selects": "Добавить варианты ответов",
        "convert": "Конвертировать",
        "exercise_from": "задание с",
        "pin_message": "Закрепить",
        "choose_education_form": "Выбрать формы обучения",
        "choose_all": "Выбрать все",
        "remove_all": "Убрать все",
        "choose_option": "Вибрать опцию",
        "hide": "Спрятать",
        "match_right": "Соедините правильно",


        "full_name": 'ФИО',
        "on_check": 'На проверку',
        "year_grade": "Годовая оценка",
        "search_group": "Поиск по группам",
        "score": "Баллы",
        "group_statistic": "К статистике групп",
        "lesson_number": "Урок №",
        "check": "Проверить",
        "exercise_answer": "Задание и ответ",
        "file": "Файл",
        "label_name": "Метки",
        "notes": "Примечания",
        "save_button": "Сохранить",
        "answer_exercise": "Выполните упражнение.",
        "score_and_comment": "Баллы и комментарий",
        "comment": "Комментарий",
        "student": "Студент",
        "one_more_try": "Дать еще одну попытку",
        "scored": "Набрано баллов",
        "automatic_questions": "Автоматические вопросы",
        "open_questions": "Открытые вопросы",
        "leave_comment": "Оставить комментарий",
        "answers": "Ответы",
        "missing": "Отсутствует",
        "document_name": "Наименование",
        "document_type": "Тип",
        "document_upload": "Файл",
        "document_upload_btn": "Отправить документ",
        "period": "Период",
        "choose_period": "Выбрать период",
        "search_course": "Поиск по названию курса",
        "search_curator_teacher": "Поиск по учителям",
        "active": "Активный",
        "role": "Роль",
        "student_role": "Студент",
        "student_billing_role": "Плательщик/студент",
        "billing_role": "Плательщик",
        "group": "Группа",
        "groups": "Группы",
        "progress": "Успеваемость",
        "curator": "Куратор",
        "go_to_payment": "Перейти к оплате",
        "packages_payment": "Пакеты и оплата",
        "payment_history": "История оплат",
        "filter": "Фильтр",
        "add_document": "Добавить документ",
        "rows": "Строк",
        "review_the_contract": "Просмотреть документ",
        "upload_doc": "Отправить документ",
        "upload_doc_pop": "Загрузить документ",
        "doc_status": {
            "require_sign": "Требуется подпись",
            "signed": "Подписан",
            "require_view": "Требуется просмотр",
            "for_familiarization": "Для ознакомления",
            "received": "Получено",
            "require_account_sign": "Требуется подпись бухгалтера",
        },
        "month": ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        "date": "Дата",
        "name_of_doc": "Название документа",
        "status": "Статус",
        "author": "Автор",
        "diary": "Дневник",
        "documents": "Документы",
        "achievements": "Достижения",
        "leaderboard_btn": "Таблица лидеров",
        "droplets": "Капельки",
        "achievements_point": "Ачивок",
        "Mon": "Пн",
        "Tue": "Вт",
        "Wed": "Ср",
        "Thu": "Чт",
        "Fri": "Пт",
        "Sat": "Сб",
        "Sun": "Вс",
        "level_title": "Уровень",
        "weekly_tasks_title": "Еженедельные задания",
        "weekly_tasks_placeholder": "Ваш ответ",
        "weekly_tasks_submit": "Отправить",
        "tasks_file_placeholder": "Прикрепить файл...",
        "curators": "Кураторы",
        "date_and_time": "Дата и время",
        "id_payment": "ID оплаты",
        "name_student": "ФИО ученика",
        "summ": "Сумма",
        "payment_for": "Оплата за",
        "total": "Всего",
        "search_history": "Поиск по истории",
        "search_documents": "Поиск по документам",
        "success_document": "Документ успешно добавлен",
        "pagination_show_count": {
            "show": "Показаны",
            "rows": "строк из"
        },
        "valid_file_types": "Допустимые типы файлов jpg, jpeg, png, pdf",
        "valid_file_types_2": "Допустимые типы файлов",
        "inn": "ИНН",
        "passport": "Серия, номер паспорта",
        "issued_passport": "Орган, что выдал",
        "date_passport_from": "Дата выдачи",
        "date_passport_to": "Действителен до",
        "user_country": "Страна проживания",
        "address_fact": "Адрес проживания",
        "diary_status": {
            "1": "Дата урока была к подписанию договора",
            "2": "Справка о болезни. Оценка не учитывается",
            "3": "Работа проверяется учителем",
            "4": "Урок не пройден. Оценка не предусмотрена",
            "5": "Урок не пройден",
            "6": "Дата урока еще не наступила",
            "7": "Урок пройден. Оценка не предусмотрена",
            "8": "Урок пройден",
            "9": "Урок на сегодня",
            "10": "Урок пройден частично",
            "11": "Оценка заморожена",
            "21": "Cтудент отчислен",
            "22": "Студент имеет пролонгацию",
            "23": "Заблокирован доступ к курсам",
        },
        "test": "тест",
        "try": "Попытка",
        "search_lesson_student": "Поиск по урокам",
        "empty_lessons_student": "В данном уроке нет студентов",
        "to_next_element": "К следующему элементу",
        "to_next_student": "К следующему студенту",
        "scored_points": "Набранно баллов",
        "thematic_evaluation": "тем. оценка",
        "annual_assessment": "годовая оценка",
        "maths": "Математика 7 класс",
        "temp_date": "пн, 13 мая",
        "temp_date_2": "ПН-ПТ з 8.30 до 16.00",
        "relevant_try": "Актуальная попытка",
        "prev_try": "Предыдущая попытка",
        "next_try": "Следующая попытка",
        "passed": "Пройдено",

        "schedule": "Расписание",
        "prev": "Предыдущая",
        "clear": "Очистить",
        "pagination_desc_part_1": "На странице отображается",
        "pagination_desc_part_2": "строка из",
        "show_results": "Показать результаты",
        "activity": "Активность",
        "sort": "Сортировать",
        "academic_year": "Учебный год",
        "schedules_empty": "По вашему запросу не найдено ни одной записи, попробуйте изменить параметры фильтрации",
        "record": "Запись",
        "record_video": "Запись видео",
        "record_audio": "Запись аудио",
        "stop": "Стоп",
        "download_file": "Загрузить",
        "add_schedule": "Добавить расписание",
        "search_name": "Поиск по ФИО",
        "gender": "Пол",
        "male": "Мужской",
        "female": "Женский",
        "birth_year": "Дата рождения",
        "last_activity": "Последний раз онлайн",
        "today": "Cегодня",
        "more_week_ago": "Больше недели назад",
        "more_month_ago": "Больше месяца назад",
        "more_half_year": "Больше полугода",
        "tables": "Табели",
        "studies_from": "Студент учится с",
        "student_status": "Статус студента",
        "classes_per_year": "Классов за год",
        "final_class": "Конечный класс",
        "for_period": "За период",
        "expelled_students": "Отчислены ученики",
        "from": "от",
        "from_on": "c",
        "to_on": "на",
        "gpa": "Средний балл",
        "number_uncompleted_works": "Кол-во несданных работ",
        "number_obligatory_works": "Кол-во обязательных несданных работ",
        "show_failed_students": "Показать только неуспевающих учеников",
        "expired_payment": "Показать только учеников с просроченным платежом",
        "student_name": "ФИО студента / ки",
        "label_name": "Метки",
        "statistics": "Статистика",
        "required": "Обязательные",
        "expecteddate_after_dedlinedate": "Ошибка даты",
        "success_journal": "Журнал успеваемости",
        "assessments_journal": "Журнал оценок",
        "alphabetically": "По алфавиту",
        "score_according": "По среднему баллу",
        "days_ago": "дней назад",
        "hours_ago": "час назад",
        "minutes_ago": "мин назад",
        "notify_parents": "Сообщение родителям",
        "notify_students": "Сообщение ученикам",
        "send_msg": "Отправить сообщение",
        "reports_actions": "Действия с табелям",
        "reports_documents": "Действия с документами",
        "data_export": "Экспорт данных",
        "provide_prolongation": "Предоставить пролонгацию",
        "view_spreadsheets": "Посмотреть табели",
        "send_everyone": "Отправить всем",
        "print": "Распечатать",
        "download_all": "Скачать все",
        "to_chat": "В чат",
        "option_must_selected": "Должна быть выбрана хотя бы одна опция",
        "curators_journal": "Журнал куратора",
        "month_label": "Месяц",
        "add_certification": "Добавить справку",
        "added_certification": "Справку успешно добавлено",
        "edit_rating": "Редактировать оценку",
        "delete_rating": "Удалить оценку",
        "add_rating": "Добавить оценку",
        "current_rating": "Текущая оценка",
        "new_rating": "Новая оценка",
        "certificate": "Справка",
        "chose_date": "Выберите дату",
        "added_rating": "Оценку успешно добавлено",
        "changed_rating": "Оценка успешно изменена",
        "deleted_rating": "Оценка успешно удалена",
        "title": "Название",
        "write_title": "Введите название",
        "details": "Описание",
        "write_details": "Введите описание",
        "action_dates": "Даты действия",
        "changed_successfully": "Изменено успешно",
        "deleted_successfully": "Удалено успешно",
        "uah": "грн",
        "details": "Реквизиты",
        "beneficiarys_bank": "Банк получателя",
        "privatbank": "АО КБ \"Приватбанк\"",
        "raiffeisen": "АО \"Райффайзен Банк Аваль\"",
        "mfo": "МФО",
        "edrpou": "код ЕГРПОУ",
        "purpose_payment": "Назначение платежа",
        "payer_payment": "внесения оплаты: за обучение (Фамилия, Имя, и Отчество Ученика / экстерном) в (соответствующем-указать цифрой) классе за соответствующий период (указать месяц или месяцы). Например: \"{last_name} {first_name} {patronymic}\"",
        "package": "Пакет",
        "subscription_amount": "Общая сумма подписки",
        "paid": "Уплачено",
        "remainder": "Остаток",
        "month_amount": "Сумма за месяц",
        "total_pay": "Всего к оплате:",
        "recipient": "Получатель",
        "cde_source": "ООО \"Центр дистанционного образования\"Джерело\"",
        "cde_source_2": "ООО \"Центр дистанционного образования\"Джерело Плюс\"",
        "whiteboard_room_fail": "Не удалось создать комнату whiteboard",
        "whiteboard_room_success": "Комната whiteboard создана успешно",
        "payers_document": "Документ плательщика",
        "accountants_document": "Документ бухгалтера",
        "create_conspectus": "Создание конспекта",
        "lesson_import_content": "Импорт контента из другого урока",
        "edit_conspectus": "Редактирование конспекта",
        "choose_pdf_material": "Выбрать PDF-файл из раздела \"Материалы\" текущего курса",
        "upload_pdf": "Загрузить PDF-файл с ПК",
        "choose_pdf": "Выберите pdf-файл",
        "choose_file": "Выбрать файл",
        "choose_range": "Выберите диапазон страниц документа (не более 20-ти)",
        "from": "с",
        "to": "по",
        "is_active": "Активен",
        "no_conspectus_images": "В конспект не загружены страницы или находятся в процессе обработки",
        "conspectus_name": "Название конспекта",
        "Conspectus": "Конспект",
        "back_to_schedules": "Назад к расписаниям",
        "added_schedule": "Расписание успешно добавлено",
        "deleted_schedule": "Расписание успешно удалено",
        "success_import_lesson_element": "Элемент урока успешно импортирован",
        "error_import_lesson_element": "Элемент урока не импортирован",
        "schedule_exist": "Расписание уже существует",
        "grade_changed": "оценка изменена",
        "status_changed": "статус изменен",
        "meddoc_deleted": "справка удалена",
        "meddoc_added": "справка добавлена",
        "meddoc_changed": "справка изменена",
        "show_btn": "Показать",
        "oops": "Упс! Что-то пошло не так (",
        "monthly": "Помесячно",
        "changed_schedule": "Расписание успешно изменено",
        "add_lesson": "Добавить урок",
        "edit_schedule": "Редактировать расписание",
        "choose_date": "Выбрать дату",
        "test_description": "Описание",
        "max_score": "Максимальное количество баллов",
        "errorTooManyAnswers": "Максимальное количество вариантов ответа",
        "to_journal": "Оценка в журнал",
        "lesson_type": "Тип урока",
        "add_score": "Добавьте оценку",
        "xls_students": "Экспорт данных студентов",
        "xls_payers": "Экспорт данных плательщиков",
        "set_class_package": "указать класс и пакет",
        "doc_list_tooltip": "<p>Уважаемые родители!</p><p>Загрузите договор и внимательно проверьте, все ли данные в договоре верны. Если есть несоответствие обратитесь в секретариат написав сообщение на VIBER на номер: +38 (097) 770 50 30</p><p>Если все верно:<br />- распечатайте договор;<br />- подпишите каждую страницу договора;<br />- отсканируйте или сделайте фото высокого качества и загрузите на сайт.</p><p>Через некоторое время на этой странице внизу будет доступна сканированная копия договора подписанного обеими сторонами.</p><p>В случае если Вам нужен оригинал договора - пожалуйста, обратитесь в секретариат.</p>",
        "change_of_details": "ВНИМАНИЕ! ИЗМЕНЕНИЕ РЕКВИЗИТОВ!!!! <br /> Обращаем Ваше внимание, что с 13 июня 2020 в связи с переходом на единый МФО, в ПриватБанке изменились счета для оплаты!",
        "add_file": "Добавить файл",
        "server_processed": "обрабатывается сервером",
        "schedule_template": "Шаблон расписания",
        "failed": "Не пройдено",
        "checking": "Проверяется",
        "new": "Новое",
        "load_error": "Ошибка загрузки данных",
        "timetable": "Расписание уроков",
        "journal_status": {
            "1": "Работа сдана успешно",
            "2": "Срок сдачи истек",
            "3": "Работа проверяется учителем",
            "4": "Предстоит сдать",
        },
        "lesson_date": "Дата урока",
        "edit_day": "Редактировать день",
        "language": "Язык",
        "grade_head": {
            "thematic": "T",
            "semester": "C",
            "year": "Г",
        },
        "first_semester": "Первый семестр",
        "second_semester": "Второй семестр",
        "next_year": "Следующий год",
        "test_results": "Результаты тестирования",
        "go_again": "Пройти еще раз",
        "shuffle_the_left_side": "Перемешать левую часть",
        "theme_to_journal": "Тема в журнал",
        "whole_schedule": "Всё расписание",
        "common_load_error": "Не удалось загрузить данные",
        "holiday": "Выходной",
        "teacher_verification": "Требует проверки учителем",
        "agree_rating": "Согласиться с оценкой",
        "attempts_left": "Осталось попыток",
        "photo_description": "Описание картинки",
        "photo_reverce": "Выводить картинки слева",
        "confirm": "Подтвердить",
        "teacher_comment": "Комментарий учителя",
        "success_job": "Работа успешно загружена",
        "recalculate_log": "Пересчитать журнал",
        "success_journal_recalc": "Журнал успешно пересчитан",
        "date_passed": "Дата прохождения",
        "delete_passing": "Удалить попытку",
        "ktp": "КТП",
        "instruction_not_found": "Инструкция не найдена",
        "screen_shots": "Скриншоты",
        "possible_answers": "Возможные ответы",
        "statement_type": "Тип ведомости",
        "student_works": "Работы",
        "student_work": "Работа",
        "completion_date": "Дата выполнения",
        "admin_notification": "Сообщение от администрации",
        "add_select_options": "Добавить селект вариантов",
        "question_missing_count": "Не совпадает количество селектов в тексте и вариантов ответа",
        "possible_answer_type_1": "Текст",
        "possible_answer_type_2": "ТеКсТ",
        "possible_answer_type_3": "Целое число",
        "possible_answer_type_4": "Число с плавающей точкой",
        "log_type": "Тип журнала",
        "confirm_deletion": "Вы уверены, что хотите удалить?",
        "student_page": "Страница ученика",
        "billing_parents": "Плательщик / Родители",
        "student_packets": "Пакеты студента",
        "no_active": "Не активный",
        "total_sum": "Общая сума",
        "payments": "грн",
        "contract_from": "Договор от",
        "contract_to": "Договор до",
        "lesson_under_development": "Урок в разработке",
        "all_classes": "Все уроки",
        "mandatory_only": "Только обязательные",
        "doing_fine": "Ты молодец! Все сдано)",
        "selected_groups": "Выбрано групп",
        "generate_spreadsheets": "Сгенерировать табели",
        "publish_spreadsheets": "Опубликовать табели",
        "export_rates": "Экспортировать оценки",
        "generate_gradereports": "Сгенерировать ведомость",
        "document": "Документ",
        "published": "Опубликован",
        "not_published": "Не опубликован",
        "no": "нет",
        "to_publish": "Опубликовать",
        "remove_doc_question": "Вы уверены, что хотите удалить документ?",
        "report_card": "Табель",
        "statement": "Ведомость",
        "available": "Доступно",
        "school_documents": "Документы из предыдущей школы",
        "additional": "Дополнительно",
        "generate_tables": "Табель будет доступен к просмотру через пару минут на вкладке \"документы\" в дополнительной информации про студента",
        "generate_gradereports_success": "Ведомость по классу будет доступна к просмотру через пару минут на вкладке документы",
        "export_studentgrades": "Ведомость будет доступна к просмотру через пару минут на вкладке \"документы\" в дополнительной информации про студента",
        "credited_not_credited": "Зачтено / Не зачтено",
        "credited": "Зачтено",
        "credited_short": "Зачет",
        "credited_not": "Не зачтено",
        "credited_not_short": "Не зачет",
        "recalculate_rating": "Пересчитать оценку",
        "recalculate_lesson": "Пересчитать урок",
        "success_lesson_recalc": "Урок успешно пересчитан",
        "delayed_till": "Отсрочка до",
        "package_blocked": "Пакет заблокирован",
        "warning": "Предупреждение",
        "prolongation": "Пролонгация",
        "rating_block": "Блокировка оценок",
        "rating_unlock": "Разблокировка оценок",
        "confirm_rating_block": "Вы уверены, что хотите заблокировать оценки?",
        "confirm_rating_unlock": "Вы уверены, что хотите разблокировать оценки?",
        "expelled": "Отчисленные",
        "not_expelled": "Не отчисленные",
        "choose_course_journal": "Выберите курс и тип журнала",
        "mass_creation": "Массовое создание",
        "journal_types": {
            "standart": "Стандарт",
            "family": "Симейная/Симейная+",
            "externat_t": "Экстернат-Т",
            "externat_r": "Экстернат-Р",
            "homeschooler": "Хоумскуллер",
        },
        "lesson_not_for_form": "Контент данного урока недоступен для вашей формы обучения",
        "for_grades": "Для оценок",
        "for_students_list": "Для списка студентов",
        "сreated_schedules": "Создаются следующие расписания:",
        "last_passing": "Это последнее прохождение студента",
        "download_time": "загрузка файла может занять некоторое время",
        "var_courses": "Вариативные курсы",
        "var_courses_shot": "Вар. курсы",
        "education_form": "Форма обучения",
        "disconnect_viber": "Отключить Viber",
        "connect_viber": "Подключить Viber",
        "disconnect_telegram": "Отключить Telegram",
        "connect_telegram": "Подключить Telegram",
        "notifications_channels": "Каналы уведомлений",
        "go_to_support_page": "Support service",
        "kw_support_title": "👋 Привет!",
        "kw_support_subtitle": "Техническая поддержка",
    },
    "ua": {
        "all": "Всі",
        "edit": "Редагувати",
        "dashboard": "Головна",
        "auth": {
            "failed": "Неправильний логін або пароль.",
            "throttle": "Занадто багато спроб входу. Будь ласка, спробуйте повторити через {seconds} секунд."
        },
        "source": "Джерело",
        "Sourcelms": "Sourcelms",
        "personal_chats": "Особисті чати",
        "profile": "Профіль",
        "logout": "Вийти",
        "login": "Логін",
        "back": "Назад",
        "password": "Пароль",
        "do_login": "Увійти",
        "forgot_password": "Забули пароль?",
        "login_error": "Помилка входу",
        "your_message": "Ваше повідомлення",
        "no_messages": "Немає повідомленнь",
        "last_messages": "Останні повідомлення",
        "new_messages": "нових повідомленнь",
        "attach_file": "Прикріпити файл",
        "drag_n_drop": "Перетягніть файл для завантаження",
        "invite_to_whiteboard": "Запросити в whiteboard",
        "whiteboard": "Whiteboard",
        "whiteboard_fail_create": "Не вдалося створити посилання на whiteboard",
        "no_cookies": "У Вашому браузері відключено читання і збереження файлів cookie",
        "enter_reset_password": "Пароль надійде вам по обраному способу відновлення",
        "reset_password": "Відновити пароль",
        "photo": "Фото",
        "upload": "Завантажити",
        "surname": "Прізвище",
        "patronymic": "По батьков",
        "admin_login": "Логін в адмін панель",
        "name": "Ім'я",
        "phone": "Телефон",
        "emailORphone": "Телефон або Email",
        "new_password": "Новий пароль",
        "confirm_new_password": "Підтвердіть новий пароль",
        "save_changes": "Зберегти зміни",
        "cancel": "Скасувати",
        "file_size_limit": "Розмір файлу перевищує 10 МБ",
        "success_saved": "Зміни успішно збережені",
        "saving_failed": "Помилка збереження даних",
        "upload_file": "Завантажте файл",
        "members": "Учасники",
        "students": "Студенти",
        "teachers": "Викладачі",
        "search": "Пошук по чату",
        "go_to_whiteboard": "Перейти в whiteboard",
        "channels": "Канали",
        "send_file_fail": "При відправці повідомлення з файлом сталася помилка",
        "only_1_file": "За один раз можна відправити тільки один файл",
        "send": "Відправити",
        "typing_one": "набирає текст...",
        "typing_more_than_one": "набирють текст...",
        "email": "Пошта",
        "to_email": "На пошту",
        "loginBy": "Зайти через",
        "resetBy": "Відновити за допомогою",
        "resetPasswordError": "Помилка під час відновлення",
        "attach_validation_error1": "Файли з цим типом розширення заборонені до завантаження",
        "attach_validation_error2": "Даний тип файлу заборонений до завантаження",
        "attach_validation_error3": "Максимально допустимий розмір файлу 1GB",
        "common_error": "Не вдалось зберегти зміни",
        "go_to_moodle": "До старих курсів",
        "go_to_courses_panel": "До курсів",
        "moodle_login": "Логін в Moodle",
        "moodle_password": "Пароль в Moodle",
        "go_to_payer_cabinet": "Кабінет батьків",
        "choose": "Вибрати",
        "choose_groups": "Вибрати групи",
        "choose_group": "Вибрати групу",
        "choosen_groups": "Вибрані групи",
        "students_groups": "Групи студентів",
        "choosen_groups_options": "Вибрані опції",
        "months": "січня,лютого,березня,квітня,травня,червня,липня,серпня,вересня,жовтня,листопада,грудня",
        "days": "понеділок,вівторок,середа,четвер,п’ятниця,субота,неділя",
        "chat": "Чат",
        "courses": "Курси",
        "add_theme": "Додати тему",
        "to_themes_list": "До списку тем",
        "back_to_course": "Назад до курсу",
        "back_to_dashboard": "Назад на головну",
        "add_test": "Додати тест",
        "Ttest": "Тест",
        "test_settings": "Налаштування тесту",
        "Test": "Тест",
        "Exercise": "Завдання",
        "Import": "Імпорт",
        "Lecture": "Лекцію",
        "Lecture_one": "Лекція",
        "To": "До",
        "Add": "Додати",
        "add_question": "Додати питання",
        "save_question": "Зберегти питання",
        "choose_question_type": "Оберіть тип питання",
        "yes_no": "Так/ Ні",
        "no": "Ні",
        "yes": "Так",
        "one_answer": "Питання з однією правильною відповіддю",
        "multichoice": "Мультивибір",
        "match_text_image": "Відповідність текст-картинка",
        "match_text_text": "Відповідність текст-текст",
        "open_question": "Коротка відповідь",
        "missing_words": "Пропущені слова",
        "total_score": "Підсумкова оцінка",
        "Question": "Питання",
        "new_lesson": "Новий урок",
        "add_selects": "Додати варіанти відповіді",
        "answer_variant": "Варіант відповіді",
        "answer_variants": "Варіанти відповідей",
        "select_variants": "Селект варіанти відповідей",
        "answer_pair_variant": "Пара опцій",
        "answer": "Відповідь",
        "add_variant": "Додати варіант",
        "save_variants": "Зберегти опції відповіді",
        "save_variants_and_question": "Зберегти опції відповіді та питання",
        "answer_correct": "правильна відповідь",
        "question_with_answer": "У питання повинна бути правильна відповідь",
        "question_text_required": "У питання повинен бути текст",
        "question_with_weight": "У питання повинен бути бал",
        "question_multiple_with_weight": "У питання з правильною відповіддю повинен бути бал",
        "time_limit": "Ліміт часу",
        "none": "немає",
        "is": "є",
        "mins": "хв",
        "show_questions_on_page": "Виводити питань на одній сторінці",
        "delete_question": "Видалити питання",
        "delete": "Видалити",
        "write_tries_count": "Введіть к-сть спроб",
        "write_questions_count": "Введіть к-сть питань",
        "test_name": "Назва тесту",
        "next": "Далі",
        "next_to": "Далі",
        "last_to": "До останньої сторінки",
        "lesson": "уроку",
        'empty_data': "Немає даних",
        'remove': 'Видалити',
        "remove_theme": "Видалити цю тему?",
        "search_theme": "Пошук по назві теми або урока",
        'empty_lessons': 'У даній темі уроків немає',
        "test_results_text": "Тут ви зможете побачити результат створеного питання",
        "test_settings_main_text": "У даному розділі наведені посадові інструкції для вчителів загальноосвітніх" +
            " навчальних закладів України.<br><br>" +
            "Посадові інструкції учителів розроблені у відповідності із Тарифно-квалiфiкацiйної характеристики\n" +
            "                вчителя, Закону України «Про освіту», Закону України «Про охорону праці», Положення про організацію\n" +
            "                роботи з охорони праці учасників навчально-виховного процесу в установах i закладах освіти, Типового\n" +
            "                положення \"Про атестацію педагогічних працівників України\", Типового положення про службу охорони праці.",
        "no_consultation": "Сьогодні немає запланованих консультацій",
        "save": "Зберегти",
        "preview": "Попередній перегляд",
        "cancel_2": "Відміна",
        "load_more": "Показати ще",
        "new_lecture": "Нова лекція",
        "edit_lecture": "Редагувати лекцію",
        "new_exercise": "Нове завдання",
        "edit_exercise": "Редагувати завдання",
        "to_lesson_content": "До змісту уроку",
        "go_to_lesson": "Перейти до уроку",
        "lecture_name": "Назва лекції",
        "exercise_name": "Назва завдання",
        "publish": "Опублікувати",
        "remove_lesson_item": "Видалити цей елемент уроку?",
        "general_information": "Загальні дані",
        "lesson_title": "Назва уроку",
        "lesson_theme": "Тема урока",
        "visibility": "Видимість",
        "lesson_description": "Опис уроку",
        "availability": "Доступність",
        "expected_completion_date": "Очікувана дата здачі",
        "action_after_expected_date": "Дія після очікуваної дати",
        "deadline": "Крайній термін здачі",
        "action_after_deadline": "Дія після крайнього терміну",
        "password_protection": "захист паролем",
        "enter_password": "Введіть пароль",
        "rating": "Оцінка",
        "rating_type": "Тип оцінки",
        "scale": "Шкала",
        "maximum_rating": "Максимальна оцінка",
        "results_processing": "Обробка результатів проб",
        "actions_options": {
            "alert": "Попередити",
            "retest": "На перездачу",
            "mark_2": "Поставити 2",
            "call_parents": "Викликати батьків",
            "deduct": "Відрахувати",
            "mark_1": "Поставити 1",
            "forbidden_passing": "Заборонити проходження",
        },
        "edit_lesson": "Редагувати урок",
        "add_new_theme": "Додати нову тему",
        "theme_name": "Назва теми",
        "save_theme": "Зберегти тему",
        "edit_theme": "Редагувати тему",
        "number_of_attempts": "Кількість спроб",
        "number_of_used_attempts": "Використаних спроб",
        "plus_lesson": "Урок",
        "element_lesson": "Елемент уроку",
        "type_result_attempts": "Тип оцінювання",
        "min_grade": "Мінімальна оцінка",
        "max_grade": "Максимальна оцінка",
        "middle_grade": "Середня оцінка",
        "nothing_found": "Ничего не найдено.",
        "nothing_found": "Нічого не знайдено.",
        "reset_search": "Скинути пошук",
        "additional_information_about_subject": "Додаткова інформація про предмет",
        "recommended_tutorials": "Рекомендовані підручники",
        "page_content": "Зміст сторінки",
        "course": "Курс",
        "materials": "Матеріали",
        "inspection_of_works": "Перевірка робіт",
        "next_lesson": "Наступний урок",
        "prev_lesson": "Попередній урок",
        "home": "Головна",
        "need_to_check": "Треба перевірити",
        "optional": "Факультатив",
        "unverified_works": "Не перевірено робіт",
        "completed_success": "Завершено (успіх)",
        "schedule_of_consultations": "Розклад консультацій",
        'remove_lesson': 'Видалити цей урок?',
        'file_error': 'Недозволений формат файлу',
        'remove_file': 'Видалити цей файл?',
        'icon': "Іконка уроку",
        'question_number': "Номер питання",
        'success_created_theme': "Тема успішно створена",
        'error_created_theme': "Виникла помилка при створенні теми",
        'success_file': "Файл успішно завантажений",
        'error_file': "Під час завантаження файлу виникли помилки",
        'success_file_remove': "Файл успішно видалений",
        "no-unread-messages": "Нових повідомлень немає",
        'error_file_remove': "Під час видалення файлу виникли помилки",
        "navigation": "Навігація",
        "search_members": "Пошук по учасниках",
        "search_members_not_found": "Не знайдено",
        "see_question_in_editor": "Перегляньте питання в редакторі",
        "on_today": "На сьогодні",
        "popular": "Популярні",
        "need_to_improve": "Треба підтягнути",
        "current_lesson": "Поточний урок",
        "previous_lesson": "Попередній урок",
        "teacher": "Вчитель",
        "teachers": "Вчителі",
        "consultations": "Консультації",
        "score_for_lesson": "оцінка за урок",
        "time_for_testing": "Час тестування",
        "test_theme": "Тест з теми",
        "minutes": "хвилин",
        "test_start": "Розпочати тест",
        "congrats_finished_ted": "Молодець! Ти завершив(ла) тестування. Очікуй на результати у найближчий час.",
        "time_is_out": "Час проходження тесту сплив.",
        "end_test": "Закінчити проходження тесту.",
        "end_test_question": "Закінчити проходження тесту?",
        "continue_to": "Перейти далі",
        "make_answer": "Відповісти",
        "return": "Повернутись",
        "your_answer": "Твоя відповідь",
        "unlimited": "Необмежено",
        "convert": "Конвертувати",
        "exercise_from": "завдання з",
        "pin_message": "Закріпити",
        "choose_education_form": "Вибрати форми навчання",
        "choose_all": "Вибрати всі",
        "remove_all": "Прибрати всі",
        "choose_option": "Вибрати опцію",
        "hide": "Сховати",
        "match_right": "З'єднайте правильно",

        "full_name": 'ПІБ',
        "on_check": 'На перевірку',
        "year_grade": 'Річна оцінка',
        "search_group": "Пошук по групам",
        "score": "Бали",
        "group_statistic": "До статистики груп",
        "lesson_number": "Урок №",
        "check": "Перевірити",
        "exercise_answer": "Завдання та відповідь",
        "file": "Файл",
        "label_name": "Мітки",
        "notes": "Примітки",
        "save_button": "Зберегти",
        "answer_exercise": "Виконайте вправу.",
        "score_and_comment": "Бали та коментар",
        "comment": "Коментар",
        "student": "Студент",
        "one_more_try": "Надати ще одну спробу",
        "scored": "Набрано балів",
        "automatic_questions": "Автоматичні питання",
        "open_questions": "Відкриті питання",
        "leave_comment": "Залишити коментар",
        "answers": "Відповіді",
        "missing": "Відсутня",
        "document_name": "Найменування",
        "document_type": "Тип",
        "document_upload": "Файл",
        "document_upload_btn": "Надіслати документ",
        "period": "Період",
        "choose_period": "Вибрати період",
        "search_course": "Пошук по назві курсу",
        "search_curator_teacher": "Пошук по вчителям",
        "active": "Активний",
        "role": "Роль",
        "student_role": "Студент",
        "student_billing_role": "Платник/студент",
        "billing_role": "Платник",
        "group": "Група",
        "groups": "Групи",
        "progress": "Успішність",
        "curator": "Куратор",
        "go_to_payment": "Пакети та деталі оплат",
        "packages_payment": "Пакети та оплата",
        "payment_history": "Історія оплат",
        "filter": "Фільтр",
        "add_document": "Додати документ",
        "rows": "Рядків",
        "review_the_contract": "Переглянути документ",
        "upload_doc": "Надіслати документ",
        "upload_doc_pop": "Завантажити документ",
        "doc_status": {
            "require_sign": "Потрібно підпис",
            "signed": "Підписано",
            "require_view": "Потрібно перегляд",
            "for_familiarization": "Для ознайомлення",
            "received": "Отримано",
            "require_account_sign": "Потрібно підпис бухгалтера",
        },
        "month": ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
        "date": "Дата",
        "name_of_doc": "Назва документу",
        "status": "Статус",
        "author": "Автор",
        "diary": "Щоденник",
        "documents": "Документи",
        "achievements": "Досягнення",
        "leaderboard_btn": "Таблиця лідерів",
        "droplets": "Краплинок",
        "achievements_point": "Ачівок",
        "Mon": "Пн",
        "Tue": "Вт",
        "Wed": "Ср",
        "Thu": "Чт",
        "Fri": "Пт",
        "Sat": "Сб",
        "Sun": "Нд",
        "level_title": "Рівень",
        "weekly_tasks_title": "Щотижневі завдання",
        "weekly_tasks_placeholder": "Ваша відповідь",
        "weekly_tasks_submit": "Надіслати",
        "tasks_file_placeholder": "Прикріпити файл...",
        "curators": "Куратори",
        "date_and_time": "Дата та час",
        "id_payment": "ID оплати",
        "name_student": "ПІБ учня",
        "summ": "Сума",
        "payment_for": "Оплата за",
        "total": "Усього",
        "search_history": "Пошук по історії",
        "search_documents": "Пошук по документам",
        "success_document": "Документ успішно додано",
        "pagination_show_count": {
            "show": "Показано",
            "rows": "рядків з"
        },
        "valid_file_types": "Допустимі типи файлів jpg, jpeg, png, pdf",
        "valid_file_types_2": "Допустимі типи файлів",
        "inn": "ІНН",
        "passport": "Серія, номер паспорта",
        "issued_passport": "Орган, що видав",
        "date_passport_from": "Дата видачі",
        "date_passport_to": "Дійсний до",
        "user_country": "Країна проживання",
        "address_fact": "Адреса проживання",
        "diary_status": {
            "1": "Дата уроку була до підписання договору",
            "2": "Довідка про хворобу. Оцінка не враховується",
            "3": "Робота перевіряється вчителем",
            "4": "Урок не пройдено. Оцінка не передбачена",
            "5": "Урок не пройдено",
            "6": "Дата уроку ще не настала",
            "7": "Урок пройдено. Оцінка не передбачена",
            "8": "Урок пройдено",
            "9": "Урок на сьогодні",
            "10": "Урок пройдено частково",
            "11": "Оцінка заморожена",
            "21": "Cтудент відрахований",
            "22": "Студент має пролонгацію",
            "23": "Заблокований доступ до курсів",
        },
        "test": "тест",
        "try": "Спроба",
        "search_lesson_student": "Пошук по урокам",
        "empty_lessons_student": "В даному уроці немає студентів",
        "to_next_element": "До наступного елементу",
        "to_next_student": "До наступного студента",
        "scored_points": "Набраних балів",
        "thematic_evaluation": "тем. оцінка",
        "annual_assessment": "річна оцінка",
        "maths": "Математика 7 клас",
        "temp_date": "пн, 13 травня",
        "temp_date_2": "ПН-ПТ з 8.30 до 16.00",
        "relevant_try": "Актуальная спроба",
        "prev_try": "Попередня спроба",
        "next_try": "Наступна спроба",
        "passed": "Пройдено",

        "schedule": "Розклад",
        "prev": "Попередня",
        "clear": "Очистити",
        "pagination_desc_part_1": "На сторінці відображається",
        "pagination_desc_part_2": "рядок з",
        "show_results": "Показати результати",
        "activity": "Активність",
        "sort": "Сортувати",
        "academic_year": "Навчальний рік",
        "schedules_empty": "За вашим запитом не знайдено жодного запису, спробуйте змінити параметри фільтрації",
        "record": "Запис",
        "record_video": "Запис відео",
        "record_audio": "Запис аудіо",
        "stop": "Стоп",
        "download_file": "Завантажити",
        "add_schedule": "Додати розклад",
        "search_name": "Пошук по ПІБ",
        "gender": "Стать",
        "male": "Чоловік",
        "female": "Жінка",
        "birth_year": "Дата народження",
        "last_activity": "Останній раз онлайн",
        "today": "Сьогодні",
        "more_week_ago": "Більше тижня тому",
        "more_month_ago": "Більше місяця тому",
        "more_half_year": "Більше півроку",
        "tables": "Табелі",
        "studies_from": "Студент навчається з",
        "student_status": "Статус студента",
        "classes_per_year": "Класів за рік",
        "final_class": "Кінцевий клас",
        "for_period": "За період",
        "expelled_students": "Відраховані учні",
        "from": "від",
        "from_on": "з",
        "to_on": "на",
        "gpa": "Середній бал",
        "number_uncompleted_works": "К-сть незданих робіт",
        "number_obligatory_works": "К-сть обов'язкових незданих робіт",
        "show_failed_students": "Показати тільки неуспішних учнів",
        "expired_payment": "Показати тільки учнів з просроченою оплатою",
        "student_name": "ПІБ студента/-ки",
        "label_name": "Мітки",
        "statistics": "Статистика",
        "required": "Обов'язкові",
        "expecteddate_after_dedlinedate": "Помилка дати",
        "success_journal": "Журнал успішності",
        "assessments_journal": "Журнал оцінок",
        "alphabetically": "За алфавітом",
        "score_according": "За середнім балом",
        "days_ago": "днів назад",
        "hours_ago": "год назад",
        "minutes_ago": "хв назад",
        "notify_parents": "Повідомлення батькам",
        "notify_students": "Повідомлення учням",
        "send_msg": "Відправити повідомлення",
        "reports_actions": "Дії з табелями",
        "reports_documents": "Дії з документами",
        "data_export": "Експорт даних",
        "provide_prolongation": "Надати пролонгацію",
        "view_spreadsheets": "Переглянути табелі",
        "send_everyone": "Відправити всім",
        "print": "Роздрукувати",
        "download_all": "Скачати всі",
        "to_chat": "В чат",
        "option_must_selected": "Повинна бути вибрана хоча б одна опція",
        "curators_journal": "Журнал куратора",
        "month_label": "Місяць",
        "add_certification": "Додати довідку",
        "added_certification": "Довідку успішно додано",
        "edit_rating": "Редагувати оцінку",
        "delete_rating": "Видалити оцінку",
        "add_rating": "Додати оцінку",
        "current_rating": "Поточна оцінка",
        "new_rating": "Нова оцінка",
        "certificate": "Довідка",
        "chose_date": "Виберiть дату",
        "added_rating": "Оцінку успішно додано",
        "changed_rating": "Оцінку успішно змінено",
        "deleted_rating": "Оцінку успішно видалено",
        "title": "Назва",
        "write_title": "Введіть назву",
        "details": "Деталі",
        "write_details": "Введіть деталі",
        "action_dates": "Дати дії",
        "changed_successfully": "Змінено успішно",
        "deleted_successfully": "Видалено успішно",
        "uah": "грн",
        "details": "Реквізити",
        "beneficiarys_bank": "Банк отримувача",
        "privatbank": "АТ КБ \"Приватбанк\"",
        "raiffeisen": "АТ \"Райффайзен Банк Аваль\"",
        "mfo": "МФО",
        "edrpou": "код ЄДРПОУ",
        "purpose_payment": "Призначення платежу",
        "payer_payment": "внесення оплати: за навчання (Призвище, Ім'я, та по Батькові Учня/Екстерна) у (відповідному-вказати цифрою) класі за відповідний період (вказати місяць або місяці). Наприклад: \"{last_name} {first_name} {patronymic}\"",
        "package": "Пакет",
        "subscription_amount": "Загальна сума підписки",
        "paid": "Cплачено",
        "remainder": "Залишок",
        "month_amount": "Сума за місяць",
        "total_pay": "Всього до сплати:",
        "recipient": "Отримувач",
        "cde_source": "ТОВ \"Центр дистанційної освіти \"Джерело\"",
        "cde_source_2": "ТОВ \"Центр дистанційної освіти \"Джерело Плюс\"",
        "whiteboard_room_fail": "Не вдалося створити кімнату whiteboard",
        "whiteboard_room_success": "Кімната whiteboard успішно створена",
        "payers_document": "Документ платника",
        "accountants_document": "Документ бухгалтера",
        "create_conspectus": "Створення конспекту",
        "lesson_import_content": "Імпорт контенту з іншого уроку",
        "edit_conspectus": "Редагування конспекту",
        "choose_pdf_material": "Вибрати PDF-файл з розділу \"Матеріали\" поточного курсу",
        "upload_pdf": "Завантажити PDF-файл з ПК",
        "choose_pdf": "Виберіть pdf-файл",
        "choose_file": "Вибрати файл",
        "choose_range": "Виберіть діапазон сторінок документа (не більше 20-ти)",
        "from": "з",
        "to": "до",
        "is_active": "Активний",
        "no_conspectus_images": "У конспект не завантажені сторінки або знаходяться в процесі обробки",
        "conspectus_name": "Назва конспекту",
        "Conspectus": "Конспект",
        "back_to_schedules": "Назад до розкладів",
        "added_schedule": "Розклад успішно додано",
        "success_import_lesson_element": "Елемент уроку успішно імпортовано",
        "error_import_lesson_element": "Елемент уроку не імпортовано",
        "deleted_schedule": "Розклад успішно видалено",
        "schedule_exist": "Розклад вже існує",
        "grade_changed": "оцінка змінена",
        "status_changed": "статус змінено",
        "meddoc_deleted": "справка видалена",
        "meddoc_added": "справка додана",
        "meddoc_changed": "справка змінена",
        "show_btn": "Показати",
        "oops": "Упс! Щось пішло не так (",
        "monthly": "Помісячно",
        "changed_schedule": "Розклад успішно змінено",
        "add_lesson": "Додати урок",
        "edit_schedule": "Редагувати розклад",
        "choose_date": "Обрати дату",
        "test_description": "Опис",
        "max_score": "Максимальна кількість балів",
        "errorTooManyAnswers": "Максимальне число варіантів відповіді",
        "to_journal": "Оцінка в журнал",
        "lesson_type": "Тип уроку",
        "add_score": "Додайте оцінку",
        "xls_students": "Експорт даних студентів",
        "xls_payers": "Експорт даних платників",
        "set_class_package": "вказати клас та пакет",
        "doc_list_tooltip": "<p>Шановні батьки!</p><p>Завантажте договір та уважно перевірте, чи усі данні в договорі вірні. Якщо є невідповідність зверніться в секретаріат написавши повідомлення на VIBER на номер: +38 (097) 770 50 30</p><p>Якщо все вірно:<br />- роздрукуйте договір;<br />- підпишіть кожну сторінку договору;<br />- зіскануйте або зробіть фото високої якості та завантажте на сайт.</p><p>Через деякий час на цій сторінці внизу буде доступна сканована копія договору підписаного обома сторонами.</p><p>В разі якщо Вам потрібен оригінал договору – будь ласка, зверніться до секретаріату.</p>",
        "change_of_details": "УВАГА! ЗМІНА РЕКВИЗИТІВ!!!!<br />Звертаємо Вашу увагу, що з 13 червня 2020 року у зв’язку із переходом на єдиний МФО, у ПриватБанку змінилися рахунки для оплати!",
        "add_file": "Додати файл",
        "server_processed": "обробляється сервером",
        "schedule_template": "Шаблон розкладу",
        "failed": "Не пройдено",
        "checking": "Перевіряється",
        "new": "Нове",
        "load_error": "Не получилось загрузить данные",
        "load_error": "Помилка завантаження даних",
        "timetable": "Розклад уроків",
        "journal_status": {
            "1": "Робота здана успішно",
            "2": "Термін здачі закінчився",
            "3": "Робота перевіряється вчителем",
            "4": "Належить скласти",
        },
        "lesson_date": "Дата уроку",
        "edit_day": "Редагувати день",
        "language": "Мова",
        "grade_head": {
            "thematic": "T",
            "semester": "С",
            "year": "Р",
        },
        "first_semester": "Перший семестр",
        "second_semester": "Другий семестр",
        "next_year": "Наступний рік",
        "test_results": "Результати тестування",
        "go_again": "Пройти ще раз",
        "shuffle_the_left_side": "Перемішати ліву частину",
        "theme_to_journal": "Тема в журнал",
        "whole_schedule": "Весь розклад",
        "common_load_error": "Не вдалося завантажити дані",
        "holiday": "Вихідний",
        "teacher_verification": "Вимагає перевірки вчителем",
        "agree_rating": "Погодитися з оцінкою",
        "attempts_left": "Залишилося спроб",
        "photo_description": "Опис зображення",
        "photo_reverce": "Виводити зображення ліворуч",
        "confirm": "Підтвердити",
        "teacher_comment": "Коментар учителя",
        "success_job": "Робота успішно завантажена",
        "recalculate_log": "Перерахувати журнал",
        "success_journal_recalc": "Журнал успішно перерахований",
        "date_passed": "Дата проходження",
        "delete_passing": "Видалити спробу",
        "ktp": "КТП",
        "instruction_not_found": "Інструкцію не знайдено",
        "screen_shots": "Скріншоти",
        "possible_answers": "Можливі відповіді",
        "statement_type": "Тип відомості",
        "student_works": "Роботи",
        "student_work": "Робота",
        "completion_date": "Дата виконання",
        "admin_notification": "Повідомлення від адміністрації",
        "add_select_options": "Додати селект варіантів",
        "question_missing_count": "Не співпадає кількість селектів в тексті і варіантів відповіді",
        "possible_answer_type_1": "Текст",
        "possible_answer_type_2": "ТеКсТ",
        "possible_answer_type_3": "Ціле число",
        "possible_answer_type_4": "Число з плаваючою точкою",
        "log_type": "Тип журналу",
        "confirm_deletion": "Ви впевнені, що хочете видалити?",
        "student_page": "Cторінка учня",
        "billing_parents": "Платники / Батьки",
        "student_packets": "Пакети студента",
        "no_active": "Не активний",
        "total_sum": "Загальна сума",
        "payments": "грн",
        "contract_from": "Договiр вiд",
        "contract_to": "Договiр до",
        "lesson_under_development": "Урок у розробці",
        "all_classes": "Всі уроки",
        "mandatory_only": "Тільки обов'язкові",
        "doing_fine": "Ти молодець! Все здано)",
        "selected_groups": "Обрано груп",
        "generate_spreadsheets": "Згенерувати табелі",
        "publish_spreadsheets": "Опублікувати табелі",
        "export_rates": "Експортувати оцінки",
        "generate_gradereports": "Згенерувати відомість",
        "document": "Документ",
        "published": "Опублікований",
        "not_published": "Не опублікований",
        "no": "Ні",
        "to_publish": "Опублікувати",
        "remove_doc_question": "Ви впевнені, що хочете видалити документ?",
        "report_card": "Табель",
        "statement": "Відомість",
        "available": "Доступно",
        "school_documents": "Документи з попередньої школи",
        "additional": "Додатково",
        "generate_tables": "Табель буде доступний для перегляду через пару хвилин на вкладці \"документи\" в додатковій інформації про студента",
        "generate_gradereports_success": "Відомість по класу буде доступна до перегляду через пару хвилин на вкладці документи",
        "export_studentgrades": "Відомість буде доступна для перегляду через пару хвилин на вкладці \"документи\" в додатковій інформації про студента",
        "credited_not_credited": "Зараховано / Не зараховано",
        "credited": "Зараховано",
        "credited_short": "Зарах.",
        "credited_not": "Не зараховано",
        "credited_not_short": "Не зарах.",
        "recalculate_rating": "Перерахувати оцінку",
        "recalculate_lesson": "Перерахувати урок",
        "success_lesson_recalc": "Урок успішно перераховано",
        "delayed_till": "Відстрочка до",
        "package_blocked": "Пакет заблокований",
        "warning": "Попередження",
        "prolongation": "Пролонгація",
        "rating_block": "Блокування оцінок",
        "rating_unlock": "Розблок-ня оцінок",
        "confirm_rating_block": "Ви впевнені, що хочете заблокувати оцінки?",
        "confirm_rating_unlock": "Ви впевнені, що хочете розблокувати оцінки?",
        "expelled": "Відраховані",
        "not_expelled": "Не відраховані",
        "choose_course_journal": "Оберіть курс та тип журналу",
        "mass_creation": "Масове створення",
        "journal_types": {
            "standart": "Стандарт",
            "family": "Сімейна/Сімейна+",
            "externat_t": "Екстернат-Т",
            "externat_r": "Екстернат-Р",
            "homeschooler": "Хоумскулер",
        },
        "lesson_not_for_form": "Контент даного уроку недоступний для Вашої форми навчання",
        "for_grades": "Для оцінок",
        "for_students_list": "Для списку студентів",
        "сreated_schedules": "Створюються наступні розклади:",
        "last_passing": "Це останнє проходження студента",
        "download_time": "завантаження файлу може зайняти деякий час",
        "var_courses": "Варіативні курси",
        "var_courses_shot": "Вар. курси",
        "education_form": "Форма навчання",
        "disconnect_viber": "Відключити Viber",
        "connect_viber": "Підключити Viber",
        "disconnect_telegram": "Відключити Telegram",
        "connect_telegram": "Підключити Telegram",
        "notifications_channels": "Канали сповіщень",
        "go_to_support_page": "Служба підтримки",
        "kw_support_title": "👋 Привіт!",
        "kw_support_subtitle": "Технічна підтримка",
    },
    "de": {
        "all": "Alle",
        "edit": "Bearbeiten",
        "auth": {
            "failed": "Diese Anmeldeinformationen stimmen nicht mit unseren Aufzeichnungen überein.",
            "throttle": "Zu viele Anmeldeversuche. Bitte versuchen Sie es in {Sekunden} Sekunden erneut."
        },
        "source": "quelle",
        "Sourcelms": "Sourcelms",
        "personal_chats": "persönliche chatrooms",
        "profile": "profil",
        "logout": "fusloggen",
        "login": "einloggen",
        "back": "zurück",
        "password": "passwort",
        "do_login": "anmeldung",
        "forgot_password": "passwort vergessen?",
        "login_error": "anmeldung fehlgeschlagen",
        "your_message": "deine nachricht",
        "last_messages": "Letzte Nachrichten",
        "no_messages": "keine neue nachrichten",
        "new_messages": "neue nachrichten",
        "attach_file": "datei anhängen",
        "drag_n_drop": "datei zum Hochladen löschen",
        "invite_to_whiteboard": "zum whiteboard einladen",
        "whiteboard": "whiteboard",
        "whiteboard_fail_create": "fehler beim erstellen des whiteboard-Links",
        "no_cookies": "ihr browser hat das lesen und speichern von cookies deaktiviert",
        "enter_reset_password": "das passwort wird ihnen gemäß der gewählten wiederherstellungsmethode gesendet",
        "reset_password": "passwort wiederherstellen",
        "photo": "foto",
        "upload": "Hochladen",
        "surname": "nachname",
        "patronymic": "vatersname",
        "admin_login": "admin login",
        "name": "vorname",
        "phone": "telefon",
        "emailORphone": "e-mail oder telefon",
        "new_password": "neues kennwort",
        "confirm_new_password": "bestätige neues Passwort",
        "save_changes": "Änderungen speichern",
        "cancel": "stornieren",
        "file_size_limit": "Die Dateigröße überschreitet 10 MB",
        "success_saved": "Änderungen wurden erfolgreich gespeichert",
        "saving_failed": "Das Speichern der Daten ist fehlgeschlagen",
        "upload_file": "datei hochladen",
        "members": "mitglieder",
        "students": "studenten",
        "teachers": "lehrer",
        "search": "suche per chat",
        "go_to_whiteboard": "gehen sie zum whiteboard",
        "channels": "kanäle",
        "send_file_fail": "beim senden einer nachricht mit der datei ist ein fehler aufgetreten",
        "only_1_file": "es kann jeweils nur eine Datei gesendet werden",
        "send": "senden",
        "typing_one": "tippt...",
        "typing_more_than_one": "tippen...",
        "email": "email",
        "to_email": "",
        "loginBy": "login von",
        "resetBy": "wiederherstellen mit",
        "resetPasswordError": "iederherstellungsfehler",
        "attach_validation_error1": "Diederherstellungsfehler",
        "attach_validation_error2": "Dieser Dateityp darf nicht hochgeladen werden.",
        "attach_validation_error3": "Die maximal zulässige Dateigröße beträgt 1 GB",
        "common_error": "Änderungen konnten nicht gespeichert werden",
        "go_to_moodle": "zu kursen",
        "go_to_courses_panel": "zu neuen kursen",
        "go_to_payer_cabinet": "Elternbüro",
        "moodle_login": "moodle login",
        "moodle_password": "moodle passwort",
        "choose": "wählen",
        "choose_groups": "wählen Sie Gruppen",
        "choose_group": "wählen Sie Gruppe",
        "choosen_groups": "gruppen auswählen",
        "students_groups": "studentengruppen",
        "choosen_groups_options": "ausgewählte optionen",
        "months": "januar, februar, märz, april, mai, juni, juli, august, september, oktober, november, dezember",
        "days": "Montag,dienstag,mittwoch,donnerstag,freitag,samstag,sonntag",
        "chat": "plaudern",
        "courses": "kurse",
        "add_theme": "thema hinzufügen",
        "to_themes_list": "zur Themenliste",
        "back_to_course": "zurück zum Kurs",
        "add_test": "test hinzufügen",
        "Ttest": "Prüfung",
        "test_settings": "testeinstellung",
        "Test": "Prüfung",
        "Exercise": "",
        "Import": "",
        "Lecture": "",
        "Lecture_one": "",
        "To": "",
        "Add": "",
        "add_question": "",
        "save_question": "",
        "choose_question_type": "",
        "yes_no": "",
        "no": "",
        "yes": "",
        "one_answer": "",
        "multichoice": "",
        "match_text_image": "",
        "match_text_text": "",
        "open_question": "",
        "missing_words": "",
        "total_score": "",
        "Question": "",
        "new_lesson": "",
        "answer_variant": "",
        "answer_pair_variant": "",
        "answer": "",
        "add_variant": "",
        "save_variants": "",
        "save_variants_and_question": "",
        "answer_correct": "",
        "question_with_answer": "",
        "question_text_required": "",
        "question_with_weight": "",
        "question_multiple_with_weight": "",
        "time_limit": "",
        "none": "",
        "is": "",
        "mins": "",
        "show_questions_on_page": "",
        "delete_question": "",
        "delete": "",
        "write_tries_count": "",
        "write_questions_count": "",
        "test_name": "",
        "next": "",
        "next_to": "",
        "last_to": "",
        "lesson": "",
        'empty_data': "",
        'remove': '',
        "remove_theme": "",
        "search_theme": "",
        'empty_lessons': '',
        "test_results_text": "",
        "test_settings_main_text": "",
        "no_consultation": "",
        "save": "",
        "preview": "",
        "cancel_2": "",
        "load_more": "",
        "new_lecture": "",
        "edit_lecture": "",
        "new_exercise": "",
        "edit_exercise": "",
        "to_lesson_content": "",
        "go_to_lesson": "",
        "lecture_name": "",
        "exercise_name": "",
        "publish": "",
        "remove_lesson_item": "",
        "general_information": "",
        "lesson_title": "",
        "lesson_theme": "",
        "visibility": "",
        "lesson_description": "",
        "availability": "",
        "expected_completion_date": "",
        "action_after_expected_date": "",
        "deadline": "",
        "action_after_deadline": "",
        "password_protection": "",
        "enter_password": "",
        "rating": "",
        "rating_type": "",
        "scale": "",
        "maximum_rating": "",
        "results_processing": "",
        "actions_options": {
            "alert": "",
            "retest": "",
            "mark_2": "",
            "call_parents": "",
            "deduct": "",
            "mark_1": "",
            "forbidden_passing": "",
        },
        "edit_lesson": "",
        "add_new_theme": "",
        "theme_name": "",
        "save_theme": "",
        "edit_theme": "",
        "number_of_attempts": "",
        "number_of_used_attempts": "",
        "plus_lesson": "",
        "element_lesson": "",
        "type_result_attempts": "",
        "min_grade": "",
        "max_grade": "",
        "middle_grade": "",
        "nothing_found": "",
        "reset_search": "",
        "additional_information_about_subject": "",
        "recommended_tutorials": "",
        "page_content": "",
        "course": "",
        "materials": "",
        "inspection_of_works": "",
        "next_lesson": "",
        "prev_lesson": "",
        "home": "",
        "need_to_check": "",
        "optional": "",
        "unverified_works": "",
        "completed_success": "",
        "schedule_of_consultations": "",
        'remove_lesson': '',
        'file_error': '',
        'remove_file': '',
        'question_number': '',
        "no-unread-messages": "",
        "navigation": "",
        "search_members": "",
        "search_members_not_found": "",
        "see_question_in_editor": "",
        "time_for_testing": "",
        "on_today": "",
        "popular": "",
        "need_to_improve": "",
        "current_lesson": "",
        "previous_lesson": "",
        "teacher": "",
        "teachers": "",
        "consultations": "",
        "score_for_lesson": "",
        "test_theme": "",
        "minutes": "",
        "test_start": "",
        "congrats_finished_ted": "",
        "time_is_out": "",
        "end_test": "",
        "end_test_question": "",
        "continue_to": "",
        "make_answer": "",
        "return": "",
        "your_answer": "",
        "exercise_from": "",
        "unlimited": "",
        "add_selects": "",
        "convert": "",
        "pin_message": "",
        "choose_education_form": "",
        "choose_all": "",
        "remove_all": "",
        "choose_option": "",
        "hide": "",
        "match_right": "",

        "score": "",
        "group_statistic": "",
        "lesson_number": "",
        "check": "",
        "exercise_answer": "",
        "file": "",
        "label_name": "",
        "notes": "",
        "save_button": "",
        "answer_exercise": "",
        "score_and_comment": "",
        "comment": "",
        "student": "",
        "one_more_try": "",
        "scored": "",
        "automatic_questions": "",
        "open_questions": "",
        "leave_comment": "",
        "answers": "",
        "missing": "",
        "test": "",
        "try": "",
        "search_lesson_student": "",
        "empty_lessons_student": "",
        "to_next_element": "",
        "to_next_student": "",
        "relevant_try": "",
        "prev_try": "",
        "next_try": "",
        "passed": "",

        "schedule": "",
        "prev": "",
        "clear": "",
        "pagination_desc_part_1": "",
        "pagination_desc_part_2": "",
        "show_results": "",
        "activity": "",
        "sort": "",
        "academic_year": "",
        "schedules_empty": "",
        "record": "",
        "record_video": "",
        "record_audio": "",
        "stop": "",
        "download_file": "",
        "add_schedule": "",
        "search_name": "",
        "gender": "",
        "male": "",
        "female": "",
        "birth_year": "",
        "last_activity": "",
        "today": "",
        "more_week_ago": "",
        "more_month_ago": "",
        "more_half_year": "",
        "tables": "",
        "studies_from": "",
        "student_status": "",
        "classes_per_year": "",
        "final_class": "",
        "for_period": "",
        "expelled_students": "",
        "from": "",
        "from_on": "",
        "to_on": "",
        "gpa": "",
        "number_uncompleted_works": "",
        "number_obligatory_works": "",
        "show_failed_students": "",
        "student_name": "",
        "label_name": "",
        "statistics": "",
        "required": "",
        "expecteddate_after_dedlinedate": "",
        "success_journal": "",
        "assessments_journal": "",
        "alphabetically": "",
        "score_according": "",
        "days_ago": "",
        "hours_ago": "",
        "minutes_ago": "",
        "notify_parents": "",
        "notify_students": "",
        "send_msg": "",
        "reports_actions": "",
        "reports_documents": "",
        "data_export": "",
        "provide_prolongation": "",
        "view_spreadsheets": "",
        "send_everyone": "",
        "print": "",
        "download_all": "",
        "to_chat": "",
        "option_must_selected": "",
        "curators_journal": "",
        "month_label": "",
        "add_certification": "",
        "added_certification": "",
        "edit_rating": "",
        "delete_rating": "",
        "add_rating": "",
        "current_rating": "",
        "new_rating": "",
        "certificate": "",
        "chose_date": "",
        "added_rating": "",
        "changed_rating": "",
        "deleted_rating": "",
        "title": "",
        "write_title": "",
        "details": "",
        "write_details": "",
        "action_dates": "",
        "changed_successfully": "",
        "deleted_successfully": "",
        "uah": "",
        "details": "",
        "beneficiarys_bank": "",
        "privatbank": "",
        "raiffeisen": "",
        "mfo": "",
        "edrpou": "",
        "purpose_payment": "",
        "payer_payment": "",
        "package": "",
        "subscription_amount": "",
        "paid": "",
        "remainder": "",
        "month_amount": "",
        "total_pay": "",
        "recipient": "",
        "cde_source": "",
        "cde_source_2": "",
        "whiteboard_room_fail": "",
        "whiteboard_room_success": "",
        "payers_document": "",
        "accountants_document": "",
        "create_conspectus": "",
        "lesson_import_content": "",
        "edit_conspectus": "",
        "choose_pdf_material": "",
        "upload_pdf": "",
        "choose_pdf": "",
        "choose_file": "",
        "choose_range": "",
        "from": "",
        "to": "",
        "is_active": "",
        "no_conspectus_images": "",
        "conspectus_name": "",
        "Conspectus": "",
        "back_to_schedules": "",
        "added_schedule": "",
        "success_import_lesson_element": "",
        "error_import_lesson_element": "",
        "deleted_schedule": "",
        "schedule_exist": "",
        "grade_changed": "",
        "status_changed": "",
        "meddoc_deleted": "",
        "meddoc_added": "",
        "meddoc_changed": "",
        "show_btn": "",
        "oops": "",
        "monthly": "",
        "changed_schedule": "",
        "add_lesson": "",
        "edit_schedule": "",
        "choose_date": "",
        "test_description": "",
        "max_score": "",
        "errorTooManyAnswers": "",
        "to_journal": "",
        "lesson_type": "",
        "add_score": "",
        "xls_students": "",
        "xls_payers": "",
        "set_class_package": "",
        "doc_list_tooltip": "",
        "change_of_details": "",
        "valid_file_types_2": "",
        "add_file": "",
        "server_processed": "",
        "schedule_template": "",
        "failed": "",
        "checking": "",
        "new": "",
        "load_error": "",
        "timetable": "",
        "journal_status": {
            "1": "",
            "2": "",
            "3": "",
            "4": "",
        },
        "lesson_date": "",
        "edit_day": "",
        "language": "",
        "grade_head": {
            "thematic": "",
            "semester": "",
            "year": "",
        },
        "first_semester": "",
        "second_semester": "",
        "next_year": "",
        "test_results": "",
        "go_again": "",
        "shuffle_the_left_side": "",
        "theme_to_journal": "",
        "whole_schedule": "",
        "common_load_error": "",
        "holiday": "",
        "teacher_verification": "",
        "agree_rating": "",
        "attempts_left": "",
        "photo_description": "",
        "photo_reverce": "",
        "confirm": "",
        "teacher_comment": "",
        "success_job": "",
        "recalculate_log": "",
        "success_journal_recalc": "",
        "date_passed": "",
        "delete_passing": "",
        "ktp": "",
        "instruction_not_found": "",
        "screen_shots": "",
        "possible_answers": "",
        "statement_type": "",
        "student_works": "",
        "student_work": "",
        "completion_date": "",
        "admin_notification": "",
        "add_select_options": "",
        "select_variants": "",
        "question_missing_count": "",
        "possible_answer_type_1": "",
        "possible_answer_type_2": "",
        "possible_answer_type_3": "",
        "possible_answer_type_4": "",
        "log_type": "",
        "confirm_deletion": "",
        "student_page": "",
        "billing_parents": "",
        "student_packets": "",
        "no_active": "",
        "total_sum": "",
        "payments": "",
        "contract_from": "",
        "contract_to": "",
        "lesson_under_development": "",
        "all_classes": "",
        "mandatory_only": "",
        "doing_fine": "",
        "selected_groups": "",
        "generate_spreadsheets": "",
        "publish_spreadsheets": "",
        "export_rates": "",
        "generate_gradereports": "",
        "document": "",
        "published": "",
        "not_published": "",
        "no": "",
        "to_publish": "",
        "remove_doc_question": "",
        "report_card": "",
        "statement": "",
        "available": "",
        "school_documents": "",
        "additional": "",
        "generate_tables": "",
        "generate_gradereports_success": "",
        "export_studentgrades": "",
        "credited_not_credited": "",
        "credited": "",
        "credited_short": "",
        "credited_not": "",
        "credited_not_short": "",
        "recalculate_rating": "",
        "recalculate_lesson": "",
        "success_lesson_recalc": "",
        "delayed_till": "",
        "package_blocked": "",
        "warning": "",
        "prolongation": "",
        "rating_block": "",
        "confirm_rating_block": "",
        "expelled": "",
        "not_expelled": "",
        "choose_course_journal": "",
        "mass_creation": "",
        "journal_types": {
            "standart": "",
            "family": "",
            "externat_t": "",
            "externat_r": "",
            "homeschooler": "",
        },
        "lesson_not_for_form": "",
        "for_grades": "",
        "for_students_list": "",
        "сreated_schedules": "",
        "last_passing": "",
        "download_time": "",
        "var_courses": "",
        "var_courses_shot": "",
        "education_form": "",
        "disconnect_viber": "Disconnect Viber",
        "connect_viber": "Connect Viber",
        "disconnect_telegram": "Disconnect Telegram",
        "connect_telegram": "Connect Telegram",
        "notifications_channels": "Benachrichtigungskanäle",
        "go_to_support_page": "Support service",
        "kw_support_title": "👋 Hi!",
        "kw_support_subtitle": "Technical Support",
    },
    "it": {
        "all": "",
        "edit": "",
        "auth": {
            "failed": "",
            "throttle": ""
        },
        "source": "",
        "Sourcelms": "Sourcelms",
        "personal_chats": "",
        "profile": "",
        "logout": "",
        "login": "",
        "back": "",
        "password": "",
        "do_login": "",
        "forgot_password": "",
        "login_error": "",
        "your_message": "",
        "last_messages": "",
        "no_messages": "",
        "new_messages": "",
        "attach_file": "",
        "drag_n_drop": "",
        "invite_to_whiteboard": "",
        "whiteboard": "",
        "whiteboard_fail_create": "",
        "no_cookies": "",
        "enter_reset_password": "",
        "reset_password": "",
        "photo": "",
        "upload": "",
        "surname": "",
        "patronymic": "",
        "admin_login": "",
        "name": "",
        "phone": "",
        "emailORphone": "",
        "new_password": "",
        "confirm_new_password": "",
        "save_changes": "",
        "cancel": "",
        "file_size_limit": "",
        "success_saved": "",
        "saving_failed": "",
        "upload_file": "",
        "members": "",
        "students": "",
        "teachers": "",
        "search": "",
        "go_to_whiteboard": "",
        "channels": "",
        "send_file_fail": "",
        "only_1_file": "",
        "send": "",
        "typing_one": "",
        "typing_more_than_one": "",
        "email": "",
        "to_email": "",
        "loginBy": "",
        "resetBy": "",
        "resetPasswordError": "",
        "attach_validation_error1": "",
        "attach_validation_error2": "",
        "attach_validation_error3": "",
        "common_error": "",
        "go_to_moodle": "",
        "go_to_courses_panel": "",
        "go_to_payer_cabinet": "",
        "moodle_login": "",
        "moodle_password": "",
        "choose": "",
        "choose_groups": "",
        "choose_group": "",
        "choosen_groups": "",
        "students_groups": "",
        "choosen_groups_options": "",
        "months": "",
        "days": "",
        "chat": "",
        "courses": "",
        "add_theme": "",
        "to_themes_list": "",
        "back_to_course": "",
        "add_test": "",
        "Ttest": "",
        "test_settings": "",
        "Test": "",
        "Exercise": "",
        "Import": "",
        "Lecture": "",
        "Lecture_one": "",
        "To": "",
        "Add": "",
        "add_question": "",
        "save_question": "",
        "choose_question_type": "",
        "yes_no": "",
        "no": "",
        "yes": "",
        "one_answer": "",
        "multichoice": "",
        "match_text_image": "",
        "match_text_text": "",
        "open_question": "",
        "missing_words": "",
        "total_score": "",
        "Question": "",
        "new_lesson": "",
        "answer_variant": "",
        "answer_pair_variant": "",
        "answer": "",
        "add_variant": "",
        "save_variants": "",
        "save_variants_and_question": "",
        "answer_correct": "",
        "question_with_answer": "",
        "question_text_required": "",
        "question_with_weight": "",
        "question_multiple_with_weight": "",
        "time_limit": "",
        "none": "",
        "is": "",
        "mins": "",
        "show_questions_on_page": "",
        "delete_question": "",
        "delete": "",
        "write_tries_count": "",
        "write_questions_count": "",
        "test_name": "",
        "next": "",
        "next_to": "",
        "last_to": "",
        "lesson": "",
        'empty_data': "",
        'remove': '',
        "remove_theme": "",
        "search_theme": "",
        'empty_lessons': '',
        "test_results_text": "",
        "test_settings_main_text": "",
        "no_consultation": "",
        "save": "",
        "preview": "",
        "cancel_2": "",
        "load_more": "",
        "new_lecture": "",
        "edit_lecture": "",
        "new_exercise": "",
        "edit_exercise": "",
        "to_lesson_content": "",
        "go_to_lesson": "",
        "lecture_name": "",
        "exercise_name": "",
        "publish": "",
        "remove_lesson_item": "",
        "general_information": "",
        "lesson_title": "",
        "lesson_theme": "",
        "visibility": "",
        "lesson_description": "",
        "availability": "",
        "expected_completion_date": "",
        "action_after_expected_date": "",
        "deadline": "",
        "action_after_deadline": "",
        "password_protection": "",
        "enter_password": "",
        "rating": "",
        "rating_type": "",
        "scale": "",
        "maximum_rating": "",
        "results_processing": "",
        "actions_options": {
            "alert": "",
            "retest": "",
            "mark_2": "",
            "call_parents": "",
            "deduct": "",
            "mark_1": "",
            "forbidden_passing": "",
        },
        "edit_lesson": "",
        "add_new_theme": "",
        "theme_name": "",
        "save_theme": "",
        "edit_theme": "",
        "number_of_attempts": "",
        "number_of_used_attempts": "",
        "plus_lesson": "",
        "element_lesson": "",
        "type_result_attempts": "",
        "min_grade": "",
        "max_grade": "",
        "middle_grade": "",
        "nothing_found": "",
        "reset_search": "",
        "additional_information_about_subject": "",
        "recommended_tutorials": "",
        "page_content": "",
        "course": "",
        "materials": "",
        "inspection_of_works": "",
        "next_lesson": "",
        "prev_lesson": "",
        "home": "",
        "need_to_check": "",
        "optional": "",
        "unverified_works": "",
        "completed_success": "",
        "schedule_of_consultations": "",
        'remove_lesson': '',
        'file_error': '',
        'remove_file': '',
        'question_number': '',
        "no-unread-messages": "",
        "navigation": "",
        "search_members": "",
        "search_members_not_found": "",
        "see_question_in_editor": "",
        "time_for_testing": "",
        "on_today": "",
        "popular": "",
        "need_to_improve": "",
        "current_lesson": "",
        "previous_lesson": "",
        "teacher": "",
        "teachers": "",
        "consultations": "",
        "score_for_lesson": "",
        "test_theme": "",
        "minutes": "",
        "test_start": "",
        "congrats_finished_ted": "",
        "time_is_out": "",
        "end_test": "",
        "end_test_question": "",
        "continue_to": "",
        "make_answer": "",
        "return": "",
        "your_answer": "",
        "exercise_from": "",
        "unlimited": "",
        "add_selects": "",
        "convert": "",
        "pin_message": "",
        "choose_education_form": "",
        "choose_all": "",
        "remove_all": "",
        "choose_option": "",
        "hide": "",
        "match_right": "",

        "score": "",
        "group_statistic": "",
        "lesson_number": "",
        "check": "",
        "exercise_answer": "",
        "file": "",
        "label_name": "",
        "notes": "",
        "save_button": "",
        "answer_exercise": "",
        "score_and_comment": "",
        "comment": "",
        "student": "",
        "one_more_try": "",
        "scored": "",
        "automatic_questions": "",
        "open_questions": "",
        "leave_comment": "",
        "answers": "",
        "missing": "",
        "test": "",
        "try": "",
        "search_lesson_student": "",
        "empty_lessons_student": "",
        "to_next_element": "",
        "to_next_student": "",
        "relevant_try": "",
        "prev_try": "",
        "next_try": "",
        "passed": "",

        "schedule": "",
        "prev": "",
        "clear": "",
        "pagination_desc_part_1": "",
        "pagination_desc_part_2": "",
        "show_results": "",
        "activity": "",
        "sort": "",
        "academic_year": "",
        "schedules_empty": "",
        "record": "",
        "record_video": "",
        "record_audio": "",
        "stop": "",
        "download_file": "",
        "add_schedule": "",
        "search_name": "",
        "gender": "",
        "male": "",
        "female": "",
        "birth_year": "",
        "last_activity": "",
        "today": "",
        "more_week_ago": "",
        "more_month_ago": "",
        "more_half_year": "",
        "tables": "",
        "studies_from": "",
        "student_status": "",
        "classes_per_year": "",
        "final_class": "",
        "for_period": "",
        "expelled_students": "",
        "from": "",
        "from_on": "",
        "to_on": "",
        "gpa": "",
        "number_uncompleted_works": "",
        "number_obligatory_works": "",
        "show_failed_students": "",
        "student_name": "",
        "label_name": "",
        "statistics": "",
        "required": "",
        "expecteddate_after_dedlinedate": "",
        "success_journal": "",
        "assessments_journal": "",
        "alphabetically": "",
        "score_according": "",
        "days_ago": "",
        "hours_ago": "",
        "minutes_ago": "",
        "notify_parents": "",
        "notify_students": "",
        "send_msg": "",
        "reports_actions": "",
        "reports_documents": "",
        "data_export": "",
        "provide_prolongation": "",
        "view_spreadsheets": "",
        "send_everyone": "",
        "print": "",
        "download_all": "",
        "to_chat": "",
        "option_must_selected": "",
        "curators_journal": "",
        "month_label": "",
        "add_certification": "",
        "added_certification": "",
        "edit_rating": "",
        "delete_rating": "",
        "add_rating": "",
        "current_rating": "",
        "new_rating": "",
        "certificate": "",
        "chose_date": "",
        "added_rating": "",
        "changed_rating": "",
        "deleted_rating": "",
        "title": "",
        "write_title": "",
        "details": "",
        "write_details": "",
        "action_dates": "",
        "changed_successfully": "",
        "deleted_successfully": "",
        "uah": "",
        "details": "",
        "beneficiarys_bank": "",
        "privatbank": "",
        "raiffeisen": "",
        "mfo": "",
        "edrpou": "",
        "purpose_payment": "",
        "payer_payment": "",
        "package": "",
        "subscription_amount": "",
        "paid": "",
        "remainder": "",
        "month_amount": "",
        "total_pay": "",
        "recipient": "",
        "cde_source": "",
        "cde_source_2": "",
        "whiteboard_room_fail": "",
        "whiteboard_room_success": "",
        "payers_document": "",
        "accountants_document": "",
        "create_conspectus": "",
        "lesson_import_content": "",
        "edit_conspectus": "",
        "choose_pdf_material": "",
        "upload_pdf": "",
        "choose_pdf": "",
        "choose_file": "",
        "choose_range": "",
        "from": "",
        "to": "",
        "is_active": "",
        "no_conspectus_images": "",
        "conspectus_name": "",
        "Conspectus": "",
        "back_to_schedules": "",
        "added_schedule": "",
        "success_import_lesson_element": "",
        "error_import_lesson_element": "",
        "deleted_schedule": "",
        "schedule_exist": "",
        "grade_changed": "",
        "status_changed": "",
        "meddoc_deleted": "",
        "meddoc_added": "",
        "meddoc_changed": "",
        "show_btn": "",
        "oops": "",
        "monthly": "",
        "changed_schedule": "",
        "add_lesson": "",
        "edit_schedule": "",
        "choose_date": "",
        "test_description": "",
        "max_score": "",
        "errorTooManyAnswers": "",
        "to_journal": "",
        "lesson_type": "",
        "add_score": "",
        "xls_students": "",
        "xls_payers": "",
        "set_class_package": "",
        "doc_list_tooltip": "",
        "change_of_details": "",
        "valid_file_types_2": "",
        "add_file": "",
        "server_processed": "",
        "schedule_template": "",
        "failed": "",
        "checking": "",
        "new": "",
        "load_error": "",
        "timetable": "",
        "journal_status": {
            "1": "",
            "2": "",
            "3": "",
            "4": "",
        },
        "lesson_date": "",
        "edit_day": "",
        "language": "",
        "grade_head": {
            "thematic": "",
            "semester": "",
            "year": "",
        },
        "first_semester": "",
        "second_semester": "",
        "next_year": "",
        "test_results": "",
        "go_again": "",
        "shuffle_the_left_side": "",
        "theme_to_journal": "",
        "whole_schedule": "",
        "common_load_error": "",
        "holiday": "",
        "teacher_verification": "",
        "agree_rating": "",
        "attempts_left": "",
        "photo_description": "",
        "photo_reverce": "",
        "confirm": "",
        "teacher_comment": "",
        "success_job": "",
        "recalculate_log": "",
        "success_journal_recalc": "",
        "date_passed": "",
        "delete_passing": "",
        "ktp": "",
        "instruction_not_found": "",
        "screen_shots": "",
        "possible_answers": "",
        "statement_type": "",
        "student_works": "",
        "student_work": "",
        "completion_date": "",
        "admin_notification": "",
        "add_select_options": "",
        "select_variants": "",
        "question_missing_count": "",
        "possible_answer_type_1": "",
        "possible_answer_type_2": "",
        "possible_answer_type_3": "",
        "possible_answer_type_4": "",
        "log_type": "",
        "confirm_deletion": "",
        "student_page": "",
        "billing_parents": "",
        "student_packets": "",
        "no_active": "",
        "total_sum": "",
        "payments": "",
        "contract_from": "",
        "contract_to": "",
        "lesson_under_development": "",
        "all_classes": "",
        "mandatory_only": "",
        "doing_fine": "",
        "selected_groups": "",
        "generate_spreadsheets": "",
        "publish_spreadsheets": "",
        "export_rates": "",
        "generate_gradereports": "",
        "document": "",
        "published": "",
        "not_published": "",
        "no": "",
        "to_publish": "",
        "remove_doc_question": "",
        "report_card": "",
        "statement": "",
        "available": "",
        "school_documents": "",
        "additional": "",
        "generate_tables": "",
        "generate_gradereports_success": "",
        "export_studentgrades": "",
        "credited_not_credited": "",
        "credited": "",
        "credited_short": "",
        "credited_not": "",
        "credited_not_short": "",
        "recalculate_rating": "",
        "recalculate_lesson": "",
        "success_lesson_recalc": "",
        "delayed_till": "",
        "package_blocked": "",
        "warning": "",
        "prolongation": "",
        "rating_block": "",
        "confirm_rating_block": "",
        "expelled": "",
        "not_expelled": "",
        "choose_course_journal": "",
        "mass_creation": "",
        "journal_types": {
            "standart": "",
            "family": "",
            "externat_t": "",
            "externat_r": "",
            "homeschooler": "",
        },
        "lesson_not_for_form": "",
        "for_grades": "",
        "for_students_list": "",
        "сreated_schedules": "",
        "last_passing": "",
        "download_time": "",
        "var_courses": "",
        "var_courses_shot": "",
        "education_form": "",
    },
    "es": {
        "all": "",
        "edit": "",
        "auth": {
            "failed": "",
            "throttle": ""
        },
        "source": "",
        "Sourcelms": "Sourcelms",
        "personal_chats": "",
        "profile": "",
        "logout": "",
        "login": "",
        "back": "",
        "password": "",
        "do_login": "",
        "forgot_password": "",
        "login_error": "",
        "your_message": "",
        "last_messages": "",
        "no_messages": "",
        "new_messages": "",
        "attach_file": "",
        "drag_n_drop": "",
        "invite_to_whiteboard": "",
        "whiteboard": "",
        "whiteboard_fail_create": "",
        "no_cookies": "",
        "enter_reset_password": "",
        "reset_password": "",
        "photo": "",
        "upload": "",
        "surname": "",
        "patronymic": "",
        "admin_login": "",
        "name": "",
        "phone": "",
        "emailORphone": "",
        "new_password": "",
        "confirm_new_password": "",
        "save_changes": "",
        "cancel": "",
        "file_size_limit": "",
        "success_saved": "",
        "saving_failed": "",
        "upload_file": "",
        "members": "",
        "students": "",
        "teachers": "",
        "search": "",
        "go_to_whiteboard": "",
        "channels": "",
        "send_file_fail": "",
        "only_1_file": "",
        "send": "",
        "typing_one": "",
        "typing_more_than_one": "",
        "email": "",
        "to_email": "",
        "loginBy": "",
        "resetBy": "",
        "resetPasswordError": "",
        "attach_validation_error1": "",
        "attach_validation_error2": "",
        "attach_validation_error3": "",
        "common_error": "",
        "go_to_moodle": "",
        "go_to_courses_panel": "",
        "go_to_payer_cabinet": "",
        "moodle_login": "",
        "moodle_password": "",
        "choose": "",
        "choose_groups": "",
        "choose_group": "",
        "choosen_groups": "",
        "students_groups": "",
        "choosen_groups_options": "",
        "months": "",
        "days": "",
        "chat": "",
        "courses": "",
        "add_theme": "",
        "to_themes_list": "",
        "back_to_course": "",
        "add_test": "",
        "Ttest": "",
        "test_settings": "",
        "Test": "",
        "Exercise": "",
        "Import": "",
        "Lecture": "",
        "Lecture_one": "",
        "To": "",
        "Add": "",
        "add_question": "",
        "save_question": "",
        "choose_question_type": "",
        "yes_no": "",
        "no": "",
        "yes": "",
        "one_answer": "",
        "multichoice": "",
        "match_text_image": "",
        "match_text_text": "",
        "open_question": "",
        "missing_words": "",
        "total_score": "",
        "Question": "",
        "new_lesson": "",
        "answer_variant": "",
        "answer_pair_variant": "",
        "add_variant": "",
        "save_variants": "",
        "save_variants_and_question": "",
        "answer_correct": "",
        "question_with_answer": "",
        "question_text_required": "",
        "question_with_weight": "",
        "question_multiple_with_weight": "",
        "time_limit": "",
        "none": "",
        "is": "",
        "mins": "",
        "show_questions_on_page": "",
        "delete_question": "",
        "delete": "",
        "write_tries_count": "",
        "write_questions_count": "",
        "test_name": "",
        "next": "",
        "next_to": "",
        "last_to": "",
        "lesson": "",
        'empty_data': "",
        'remove': '',
        "remove_theme": "",
        "search_theme": "",
        'empty_lessons': '',
        "test_results_text": "",
        "test_settings_main_text": "",
        "no_consultation": "",
        "save": "",
        "preview": "",
        "cancel_2": "",
        "load_more": "",
        "new_lecture": "",
        "edit_lecture": "",
        "new_exercise": "",
        "edit_exercise": "",
        "to_lesson_content": "",
        "go_to_lesson": "",
        "lecture_name": "",
        "exercise_name": "",
        "publish": "",
        "remove_lesson_item": "",
        "general_information": "",
        "lesson_title": "",
        "lesson_theme": "",
        "visibility": "",
        "lesson_description": "",
        "availability": "",
        "expected_completion_date": "",
        "action_after_expected_date": "",
        "deadline": "",
        "action_after_deadline": "",
        "password_protection": "",
        "enter_password": "",
        "rating": "",
        "rating_type": "",
        "scale": "",
        "maximum_rating": "",
        "results_processing": "",
        "actions_options": {
            "alert": "",
            "retest": "",
            "mark_2": "",
            "call_parents": "",
            "deduct": "",
            "mark_1": "",
            "forbidden_passing": "",
        },
        "edit_lesson": "",
        "add_new_theme": "",
        "theme_name": "",
        "save_theme": "",
        "edit_theme": "",
        "number_of_attempts": "",
        "number_of_used_attempts": "",
        "plus_lesson": "",
        "element_lesson": "",
        "type_result_attempts": "",
        "min_grade": "",
        "max_grade": "",
        "middle_grade": "",
        "nothing_found": "",
        "reset_search": "",
        "additional_information_about_subject": "",
        "recommended_tutorials": "",
        "page_content": "",
        "course": "",
        "materials": "",
        "inspection_of_works": "",
        "next_lesson": "",
        "prev_lesson": "",
        "home": "",
        "need_to_check": "",
        "optional": "",
        "unverified_works": "",
        "completed_success": "",
        "schedule_of_consultations": "",
        'remove_lesson': '',
        'file_error': '',
        'remove_file': '',
        'question_number': '',
        "no-unread-messages": "",
        "navigation": "",
        "search_members": "",
        "search_members_not_found": "",
        "see_question_in_editor": "",
        "time_for_testing": "",
        "on_today": "",
        "popular": "",
        "need_to_improve": "",
        "current_lesson": "",
        "previous_lesson": "",
        "teacher": "",
        "teachers": "",
        "consultations": "",
        "score_for_lesson": "",
        "test_theme": "",
        "minutes": "",
        "test_start": "",
        "congrats_finished_ted": "",
        "time_is_out": "",
        "end_test": "",
        "end_test_question": "",
        "continue_to": "",
        "make_answer": "",
        "return": "",
        "your_answer": "",
        "exercise_from": "",
        "unlimited": "",
        "add_selects": "",
        "convert": "",
        "pin_message": "",
        "choose_education_form": "",
        "choose_all": "",
        "remove_all": "",
        "choose_option": "",
        "hide": "",
        "match_right": "",
        "score": "",
        "group_statistic": "",
        "lesson_number": "",
        "check": "",
        "exercise_answer": "",
        "file": "",
        "label_name": "",
        "notes": "",
        "save_button": "",
        "answer_exercise": "",
        "score_and_comment": "",
        "comment": "",
        "student": "",
        "one_more_try": "",
        "scored": "",
        "automatic_questions": "",
        "open_questions": "",
        "leave_comment": "",
        "answers": "",
        "answer": "",
        "missing": "",
        "test": "",
        "try": "",
        "search_lesson_student": "",
        "empty_lessons_student": "",
        "to_next_element": "",
        "to_next_student": "",
        "relevant_try": "",
        "prev_try": "",
        "next_try": "",
        "passed": "",

        "schedule": "",
        "prev": "",
        "clear": "",
        "pagination_desc_part_1": "",
        "pagination_desc_part_2": "",
        "show_results": "",
        "activity": "",
        "sort": "",
        "academic_year": "",
        "schedules_empty": "",
        "record": "",
        "record_video": "",
        "record_audio": "",
        "stop": "",
        "download_file": "",
        "add_schedule": "",
        "search_name": "",
        "gender": "",
        "male": "",
        "female": "",
        "birth_year": "",
        "last_activity": "",
        "today": "",
        "more_week_ago": "",
        "more_month_ago": "",
        "more_half_year": "",
        "tables": "",
        "studies_from": "",
        "student_status": "",
        "classes_per_year": "",
        "final_class": "",
        "for_period": "",
        "expelled_students": "",
        "from": "",
        "from_on": "",
        "to_on": "",
        "gpa": "",
        "number_uncompleted_works": "",
        "number_obligatory_works": "",
        "show_failed_students": "",
        "student_name": "",
        "label_name": "",
        "statistics": "",
        "required": "",
        "expecteddate_after_dedlinedate": "",
        "success_journal": "",
        "assessments_journal": "",
        "alphabetically": "",
        "score_according": "",
        "days_ago": "",
        "hours_ago": "",
        "minutes_ago": "",
        "notify_parents": "",
        "notify_students": "",
        "send_msg": "",
        "reports_actions": "",
        "reports_documents": "",
        "data_export": "",
        "provide_prolongation": "",
        "view_spreadsheets": "",
        "send_everyone": "",
        "print": "",
        "download_all": "",
        "to_chat": "",
        "option_must_selected": "",
        "curators_journal": "",
        "month_label": "",
        "add_certification": "",
        "added_certification": "",
        "edit_rating": "",
        "delete_rating": "",
        "add_rating": "",
        "current_rating": "",
        "new_rating": "",
        "certificate": "",
        "chose_date": "",
        "added_rating": "",
        "changed_rating": "",
        "deleted_rating": "",
        "title": "",
        "write_title": "",
        "details": "",
        "write_details": "",
        "action_dates": "",
        "changed_successfully": "",
        "deleted_successfully": "",
        "uah": "",
        "details": "",
        "beneficiarys_bank": "",
        "privatbank": "",
        "raiffeisen": "",
        "mfo": "",
        "edrpou": "",
        "purpose_payment": "",
        "payer_payment": "",
        "package": "",
        "subscription_amount": "",
        "paid": "",
        "remainder": "",
        "month_amount": "",
        "total_pay": "",
        "recipient": "",
        "cde_source": "",
        "cde_source_2": "",
        "whiteboard_room_fail": "",
        "whiteboard_room_success": "",
        "payers_document": "",
        "accountants_document": "",
        "create_conspectus": "",
        "lesson_import_content": "",
        "edit_conspectus": "",
        "choose_pdf_material": "",
        "upload_pdf": "",
        "choose_pdf": "",
        "choose_file": "",
        "choose_range": "",
        "from": "",
        "to": "",
        "is_active": "",
        "no_conspectus_images": "",
        "conspectus_name": "",
        "Conspectus": "",
        "back_to_schedules": "",
        "added_schedule": "",
        "success_import_lesson_element": "",
        "error_import_lesson_element": "",
        "deleted_schedule": "",
        "schedule_exist": "",
        "grade_changed": "",
        "status_changed": "",
        "meddoc_deleted": "",
        "meddoc_added": "",
        "meddoc_changed": "",
        "show_btn": "",
        "oops": "",
        "monthly": "",
        "changed_schedule": "",
        "add_lesson": "",
        "edit_schedule": "",
        "choose_date": "",
        "test_description": "",
        "max_score": "",
        "errorTooManyAnswers": "",
        "to_journal": "",
        "lesson_type": "",
        "add_score": "",
        "xls_students": "",
        "xls_payers": "",
        "set_class_package": "",
        "doc_list_tooltip": "",
        "change_of_details": "",
        "valid_file_types_2": "",
        "add_file": "",
        "server_processed": "",
        "schedule_template": "",
        "failed": "",
        "checking": "",
        "new": "",
        "load_error": "",
        "timetable": "",
        "journal_status": {
            "1": "",
            "2": "",
            "3": "",
            "4": "",
        },
        "lesson_date": "",
        "edit_day": "",
        "language": "",
        "grade_head": {
            "thematic": "",
            "semester": "",
            "year": "",
        },
        "first_semester": "",
        "second_semester": "",
        "next_year": "",
        "test_results": "",
        "go_again": "",
        "shuffle_the_left_side": "",
        "go_to_payer_cabinet": "",
        "theme_to_journal": "",
        "whole_schedule": "",
        "common_load_error": "",
        "holiday": "",
        "teacher_verification": "",
        "agree_rating": "",
        "attempts_left": "",
        "photo_description": "",
        "photo_reverce": "",
        "confirm": "",
        "teacher_comment": "",
        "success_job": "",
        "recalculate_log": "",
        "success_journal_recalc": "",
        "date_passed": "",
        "delete_passing": "",
        "ktp": "",
        "instruction_not_found": "",
        "screen_shots": "",
        "possible_answers": "",
        "statement_type": "",
        "student_works": "",
        "student_work": "",
        "completion_date": "",
        "admin_notification": "",
        "add_select_options": "",
        "select_variants": "",
        "question_missing_count": "",
        "possible_answer_type_1": "",
        "possible_answer_type_2": "",
        "possible_answer_type_3": "",
        "possible_answer_type_4": "",
        "log_type": "",
        "confirm_deletion": "",
        "student_page": "",
        "billing_parents": "",
        "student_packets": "",
        "no_active": "",
        "total_sum": "",
        "payments": "",
        "contract_from": "",
        "contract_to": "",
        "lesson_under_development": "",
        "all_classes": "",
        "mandatory_only": "",
        "doing_fine": "",
        "selected_groups": "",
        "generate_spreadsheets": "",
        "publish_spreadsheets": "",
        "export_rates": "",
        "generate_gradereports": "",
        "document": "",
        "published": "",
        "not_published": "",
        "no": "",
        "to_publish": "",
        "remove_doc_question": "",
        "report_card": "",
        "statement": "",
        "available": "",
        "school_documents": "",
        "additional": "",
        "generate_tables": "",
        "generate_gradereports_success": "",
        "export_studentgrades": "",
        "credited_not_credited": "",
        "credited": "",
        "credited_short": "",
        "credited_not": "",
        "credited_not_short": "",
        "recalculate_rating": "",
        "recalculate_lesson": "",
        "success_lesson_recalc": "",
        "delayed_till": "",
        "package_blocked": "",
        "warning": "",
        "prolongation": "",
        "rating_block": "",
        "confirm_rating_block": "",
        "expelled": "",
        "not_expelled": "",
        "choose_course_journal": "",
        "mass_creation": "",
        "journal_types": {
            "standart": "",
            "family": "",
            "externat_t": "",
            "externat_r": "",
            "homeschooler": "",
        },
        "lesson_not_for_form": "",
        "for_grades": "",
        "for_students_list": "",
        "сreated_schedules": "",
        "last_passing": "",
        "download_time": "",
        "var_courses": "",
        "var_courses_shot": "",
        "education_form": "",
    },

}
/*
Dummy to use if new lang
TODO: DON'T FORGET TO ADD NEW TRANSLATE WHEN IT APPEARS

"short_name_of_your_lang": {
    "all": "",
        "edit": "",
        "auth": {
        "failed": "",
            "throttle": ""
    },
    "source": "",
    "Sourcelms": "Sourcelms",
    "personal_chats": "",
    "profile": "",
    "logout": "",
    "login": "",
    "back": "",
    "password": "",
    "do_login": "",
    "forgot_password": "",
    "login_error": "",
    "your_message": "",
    "last_messages": "",
    "no_messages": "",
    "new_messages": "",
    "attach_file": "",
    "drag_n_drop": "",
    "invite_to_whiteboard": "",
    "whiteboard": "",
    "whiteboard_fail_create": "",
    "no_cookies": "",
    "enter_reset_password": "",
    "reset_password": "",
    "photo": "",
    "upload": "",
    "surname": "",
    "patronymic": "",
    "admin_login": "",
    "name": "",
    "phone": "",
    "emailORphone": "",
    "new_password": "",
    "confirm_new_password": "",
    "save_changes": "",
    "cancel": "",
    "file_size_limit": "",
    "success_saved": "",
    "saving_failed": "",
    "upload_file": "",
    "members": "",
    "students": "",
    "teachers": "",
    "search": "",
    "go_to_whiteboard": "",
    "channels": "",
    "send_file_fail": "",
    "only_1_file": "",
    "send": "",
    "typing_one": "",
    "typing_more_than_one": "",
    "email": "",
    "to_email": "",
    "loginBy": "",
    "resetBy": "",
    "resetPasswordError": "",
    "attach_validation_error1": "",
    "attach_validation_error2": "",
    "attach_validation_error3": "",
    "common_error": "",
    "go_to_moodle": "",
    "go_to_courses_panel": "",
    "go_to_payer_cabinet": "",
    "moodle_login": "",
    "moodle_password": "",
    "choose": "",
    "choose_groups": "",
    "choose_group": "",
    "choosen_groups": "",
    "students_groups": "",
    "choosen_groups_options": "",
    "months": "",
    "days": "",
    "chat": "",
    "courses":"",
    "add_theme": "",
    "to_themes_list": "",
    "back_to_course": "",
    "add_test": "",
    "Ttest": "",
    "test_settings": "",
    "Test": "",
    "Exercise": "",
    "Lecture": "",
    "Lecture_one": "",
    "To": "",
    "Add": "",
    "add_question": "",
    "save_question": "",
    "choose_question_type": "",
    "yes_no": "",
    "no": "",
    "yes": "",
    "one_answer": "",
    "multichoice": "",
    "match_text_image": "",
    "match_text_text": "",
    "open_question": "",
    "missing_words": "",
    "total_score": "",
    "Question": "",
    "new_lesson": "",
    "answer_variant": "",
    "answer_pair_variant": "",
    "answer": "",
    "add_variant": "",
    "save_variants": "",
    "save_variants_and_question": "",
    "answer_correct": "",
    "question_with_answer": "",
    "question_text_required": "",
    "question_with_weight": "",
    "question_multiple_with_weight": "",
    "time_limit": "",
    "none": "",
    "is": "",
    "mins": "",
    "show_questions_on_page": "",
    "delete_question": "",
    "delete": "",
    "write_tries_count": "",
    "write_questions_count": "",
    "test_name": "",
    "next": "",
    "next_to": "",
    "last_to": "",
    "lesson": "",
    'empty_data': "",
    'remove': '',
    "remove_theme": "",
    "search_theme": "",
    'empty_lessons': '',
    "test_results_text": "",
    "test_settings_main_text": "",
    "no_consultation": "",
    "save": "",
    "preview": "",
    "cancel_2": "",
    "load_more": "",
    "new_lecture": "",
    "edit_lecture": "",
    "new_exercise": "",
    "edit_exercise": "",
    "to_lesson_content": "",
    "go_to_lesson": "",
    "lecture_name": "",
    "exercise_name": "",
    "publish": "",
    "remove_lesson_item": "",
    "general_information": "",
    "lesson_title": "",
    "lesson_theme": "",
    "visibility": "",
    "lesson_description": "",
    "availability": "",
    "expected_completion_date": "",
    "action_after_expected_date": "",
    "deadline": "",
    "action_after_deadline": "",
    "password_protection": "",
    "enter_password": "",
    "rating": "",
    "rating_type": "",
    "scale": "",
    "maximum_rating": "",
    "results_processing": "",
    "actions_options": {
    "alert": "",
        "retest": "",
        "mark_2": "",
        "call_parents": "",
        "deduct": "",
        "mark_1": "",
        "forbidden_passing": "",
    },
    "edit_lesson": "",
    "add_new_theme": "",
    "theme_name": "",
    "save_theme": "",
    "edit_theme": "",
    "number_of_attempts": "",
    "number_of_used_attempts": "",
    "plus_lesson": "",
    "type_result_attempts": "",
    "min_grade": "",
    "max_grade": "",
    "middle_grade": "",
    "nothing_found": "",
    "reset_search": "",
    "additional_information_about_subject": "",
    "recommended_tutorials": "",
    "page_content": "",
    "course": "",
    "materials": "",
    "inspection_of_works": "",
    "next_lesson": "",
    "prev_lesson": "",
    "home": "",
    "need_to_check": "",
    "optional": "",
    "unverified_works": "",
    "completed_success": "",
    "schedule_of_consultations": "",
    'remove_lesson': '',
    'file_error': '',
    'remove_file': '',
    'question_number': '',
    "no-unread-messages": "",
    "navigation": "",
    "search_members": "",
    "search_members_not_found": "",
    "see_question_in_editor": "",
    "time_for_testing": "",
    "on_today": "",
    "popular": "",
    "need_to_improve": "",
    "current_lesson": "",
    "previous_lesson": "",
    "teacher": "",
    "teachers": "",
    "consultations": "",
    "score_for_lesson": "",
    "test_theme": "",
    "minutes": "",
    "test_start": "",
    "congrats_finished_ted": "",
    "time_is_out": "",
    "end_test": "",
    "end_test_question": "",
    "continue_to": "",
    "make_answer": "",
    "return": "",
    "your_answer": "",
    "exercise_from": "",
    "unlimited": "",
    "add_selects": "",
    "convert": "",
    "pin_message": "",
    "choose_education_form": "",
    "choose_all": "",
    "remove_all": "",
    "choose_option": "",
    "hide": "",
    "match_right": "",

    "score": "",
    "group_statistic": "",
    "lesson_number": "",
    "check": "",
    "exercise_answer": "",
    "file": "",
    "label_name": "",
    "notes": "",
    "save_button": "",
    "answer_exercise": "",
    "score_and_comment": "",
    "comment": "",
    "student": "",
    "one_more_try": "",
    "scored": "",
    "automatic_questions": "",
    "open_questions": "",
    "leave_comment": "",
    "answers": "",
    "answer": "",
    "missing": "",
    "test": "",
    "try": "",
    "search_lesson_student": "",
    "empty_lessons_student": "",
    "to_next_element": "",
    "to_next_student": "",
    "relevant_try": "",
    "prev_try": "",
    "next_try": "",
    "passed": "",

    "schedule": "",
    "prev": "",
    "clear": "",
    "pagination_desc_part_1": "",
    "pagination_desc_part_2": "",
    "show_results": "",
    "activity": "",
    "sort": "",
    "academic_year": "",
    "schedules_empty": "",
    "record": "",
    "record_video": "",
    "record_audio": "",
    "stop": "",
    "download_file": "",
    "add_schedule": "",
    "search_name": "",
    "gender": "",
    "male": "",
    "female": "",
    "birth_year": "",
    "last_activity": "",
    "today": "",
    "more_week_ago": "",
    "more_month_ago": "",
    "more_half_year": "",
    "tables": "",
    "studies_from": "",
    "student_status": "",
    "classes_per_year": "",
    "final_class": "",
    "for_period": "",
    "expelled_students": "",
    "from": "",
    "from_on": "",
    "to_on": "",
    "gpa": "",
    "number_uncompleted_works": "",
    "number_obligatory_works": "",
    "show_failed_students": "",
    "student_name": "",
    "label_name": "",
    "statistics": "",
    "required": "",
    "success_journal": "",
    "assessments_journal": "",
    "alphabetically": "",
    "score_according": "",
    "days_ago": "",
    "hours_ago": "",
    "minutes_ago": "",
    "notify_parents": "",
    "notify_students": "",
    "send_msg": "",
    "reports_actions": "",
    "reports_documents": "",
    "data_export": "",
    "provide_prolongation": "",
    "view_spreadsheets": "",
    "send_everyone": "",
    "print": "",
    "download_all": "",
    "to_chat": "",
    "option_must_selected": "",
    "curators_journal": "",
    "month_label": "",
    "add_certification": "",
    "added_certification": "",
    "edit_rating": "",
    "delete_rating": "",
    "add_rating": "",
    "current_rating": "",
    "new_rating": "",
    "certificate": "",
    "chose_date" : "",
    "added_rating": "",
    "changed_rating": "",
    "deleted_rating": "",
    "title": "",
    "write_title": "",
    "details": "",
    "write_details": "",
    "action_dates": "",
    "changed_successfully": "",
    "deleted_successfully": "",
    "uah": "",
    "details": "",
    "beneficiarys_bank": "",
    "privatbank": "",
    "raiffeisen": "",
    "mfo": "",
    "edrpou": "",
    "purpose_payment": "",
    "payer_payment": "",
    "package": "",
    "subscription_amount": "",
    "paid": "",
    "remainder": "",
    "month_amount": "",
    "total_pay": "",
    "recipient": "",
    "cde_source": "",
    "cde_source_2": "",
    "whiteboard_room_fail": "",
    "whiteboard_room_success": "",
    "payers_document": "",
    "accountants_document": "",
    "create_conspectus": "",
    "edit_conspectus": "",
    "choose_pdf_material": "",
    "upload_pdf": "",
    "choose_pdf": "",
    "choose_file": "",
    "choose_range": "",
    "from": "",
    "to": "",
    "is_active": "",
    "no_conspectus_images": "",
    "conspectus_name": "",
    "Conspectus": "",
    "back_to_schedules": "",
    "added_schedule": "",
    "deleted_schedule": "",
    "schedule_exist": "",
    "grade_changed": "",
    "status_changed": "",
    "meddoc_deleted": "",
    "meddoc_added": "",
    "meddoc_changed": "",
    "show_btn": "",
    "oops": "",
    "monthly": "",
    "changed_schedule": "",
    "add_lesson": "",
    "edit_schedule": "",
    "choose_date": "",
    "test_description": "",
    "max_score": "",
    "errorTooManyAnswers": "",
    "to_journal": "",
    "lesson_type": "",
    "add_score": "",
    "xls_students": "",
    "xls_payers": "",
    "set_class_package": "",
    "doc_list_tooltip": "",
    "change_of_details": "",
    "valid_file_types_2": "",
    "add_file": "",
    "server_processed": "",
    "schedule_template": "",
    "failed": "",
    "checking": "",
    "new": "",
    "load_error": "",
    "timetable": "",
    "journal_status": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
    },
    "lesson_date": "",
    "edit_day": "",
    "language": "",
    "grade_head": {
        "thematic": "",
        "semester": "",
        "year": "",
    },
    "first_semester": "",
    "second_semester": "",
    "next_year": "",
    "test_results": "",
    "go_again": "",
    "shuffle_the_left_side": "",
    "theme_to_journal": "",
    "whole_schedule": "",
    "common_load_error": "",
    "holiday": "",
    "teacher_verification": "",
    "agree_rating": "",
    "attempts_left": "",
    "photo_description": "",
    "photo_reverce": "",
    "confirm": "",
    "teacher_comment": "",
    "success_job": "",
    "recalculate_log": "",
    "success_journal_recalc": "",
    "date_passed": "",
    "delete_passing": "",
    "ktp": "",
    "instruction_not_found": "",
    "screen_shots": "",
    "possible_answers": "",
    "statement_type": "",
    "student_works": "",
    "student_work": "",
    "completion_date": "",
    "admin_notification": "",
    "add_select_options": "",
    "select_variants": "",
    "question_missing_count": "",
    "possible_answer_type_1": "",
    "possible_answer_type_2": "",
    "possible_answer_type_3": "",
    "possible_answer_type_4": "",
    "log_type": "",
    "confirm_deletion": "",
    "student_page": "",
    "billing_parents": "",
    "student_packets" : "",
    "no_active" : "",
    "total_sum" : "",
    "payments" : "",
    "contract_from" : "",
    "contract_to" : "",
    "lesson_under_development" : "",
    "all_classes" : "",
    "mandatory_only" : "",
    "doing_fine" : "",
    "selected_groups" : "",
    "generate_spreadsheets" : "",
    "publish_spreadsheets" : "",
    "export_rates": "",
    "generate_gradereports": "",
    "document": "",
    "published": "",
    "not_published": "",
    "no": "",
    "to_publish": "",
    "remove_doc_question": "",
    "report_card": "",
    "statement": "",
    "available": "",
    "school_documents": "",
    "additional": "",
    "generate_tables": "",
    "generate_gradereports_success": "",
    "export_studentgrades": "",
    "credited_not_credited": "",
    "credited": "",
    "credited_short": "",
    "credited_not": "",
    "credited_not_short": "",
    "recalculate_rating": "",
    "recalculate_lesson": "",
    "success_lesson_recalc": "",
    "delayed_till": "",
    "package_blocked": "",
    "warning": "",
    "prolongation": "",
    "rating_block": "",
    "confirm_rating_block": "",
    "expelled": "",
    "not_expelled": "",
    "choose_course_journal": "",
    "mass_creation": "",
    "journal_types": {
        "standart": "",
        "family": "",
        "externat_t": "",
        "externat_r": "",
        "homeschooler": "",
    },
    "lesson_not_for_form": "",
    "for_grades": "",
    "for_students_list": "",
    "сreated_schedules": "",
    "last_passing": "",
    "download_time": "",
    "var_courses": "",
    "var_courses_shot": "",
    "education_form": "",
*/
